/* dd */
// Dropdown
function formDropdownClose(base) {
    var parentNode = base.parentNode;
    var btn = parentNode.getElementsByClassName('form-dropdown-btn')[0];
    formDropdownToggle(btn);
}

function formDropdownChooseItem(ev, base) {
	ev.preventDefault();

    var baseNode = base.parentNode.parentNode.parentNode.parentNode;
    var btn = baseNode.getElementsByClassName('form-dropdown-btn')[0];
    btn.innerHTML = base.text + "<span class='fa fa-angle-up'></span>";
    formDropdownToggle(btn);
    gotToLinkWithSearchPrams(base.href);
    return false; // Prevent link
}

function gotToLinkWithSearchPrams(link) {
	if(!link) return;
	let searchItem = document.getElementById('search-bar');
	let searchQuery = '';
	if(searchItem.value) searchQuery = '?q=' + searchItem.value;
	window.location.href = link + searchQuery;
	return
}

function formDropdownToggle(base) {
    let children = base.children;
    let className = children[0].className;
    let parentNode = base.parentNode;
    let menu = parentNode.getElementsByClassName('form-dropdown-menu')[0];
    let close = parentNode.getElementsByClassName('form-dropdown-btn-close')[0];

    if(className === 'fa fa-angle-up')
    {
        children[0].className = 'fa fa-angle-down';
        menu.style.display = 'none';
        close.style.display = 'none';
    }
    else
    {
        children[0].className = 'fa fa-angle-up';
        menu.style.display = 'block';
        close.style.display = 'block';
    }
}

function removeSelectItems(ob) {
	while (ob.options.length) ob.remove(0);
}

const cacheUserNameHelper = {
	el: {
		login: document.getElementById('js-login-btn')
	},
	state:{
		isLogin: false,
		dashboard: null,
	},
	init: function(){
		if(this.el.login){
			this.setUserName();
		}
	},
	isLogin(){
		return this.state.isLogin;
	},
	getPathToDashboard(){
		return this.state.dashboard;
	},
	setUserName: function(){
		// Temp localstorage
		let data = window.localStorage.getItem('account.json');
		if(data){
			this.renderUserName(JSON.parse(data));
		}
		fetch('/api/status/username')
			.then(async r => {
				if (r.status === 204) {
					window.localStorage.removeItem('account.json');
					this.renderUserName(null);
					return;
				}
				if (r.status !== 200) {
					console.error('status: ' + r.status);
					return;
				}

				// const json = await r.json();
				const jsonStr = await r.text();
				const json = JSON.parse(jsonStr);
				if(jsonStr){
					window.localStorage.setItem('account.json', jsonStr);
					this.renderUserName(json);
				}
				else{
					this.renderUserName(null);
				}
			});
	},
	renderUserName: function (json) {
		if(json && json.name){
			this.state.isLogin = true;
			this.state.dashboard = json.path;
			this.el.login.innerText = json.name;
			this.el.login.href = json.path;
		}
		else{
			this.state.isLogin = false;
			this.el.login.innerText = 'Inloggen';
			this.el.login.href = '/login';
			this.state.dashboard = '/login';
		}
	}
}
// Dependent
cacheUserNameHelper.init();
const clientCards = {
    init() {
        const track = document.getElementById('clientTrack');
        const prev = document.querySelector('.client-nav-prev');
        const next = document.querySelector('.client-nav-next');

        if (!track || !prev || !next) return;

        const getScrollAmount = () => {
            const card = track.querySelector('.client-card');
            if (!card) return 360;
            const gap = parseInt(getComputedStyle(track).columnGap || 30, 10);
            return card.offsetWidth + gap;
        };

        prev.addEventListener('click', () => track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }));
        next.addEventListener('click', () => track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }));
    }
};
const cspMove = {
	openCalendly(){
		let list = document.querySelectorAll('.js-calendly-open');
		list.forEach(item => {
			item.addEventListener('click', e => {
				e.preventDefault();
				Calendly.initPopupWidget({url: 'https://calendly.com/1stalling?hide_gdpr_banner=1'})
			});
		});
	}
}

class DemoBarPlanner {
	constructor() {
		const wrapper = document.querySelector('.demo-bar-wrapper');
		const closeBtn = document.querySelector('.demo-close');

		if (!wrapper) return;

		window.addEventListener('scroll', () => {
			wrapper.classList.toggle('hidden', window.scrollY <= 400);
		});

		closeBtn?.addEventListener('click', () => wrapper.remove());
	}
}
let enumList = {
    country: {
        nl: 'NL',
        be: 'BE',
        de: 'DE',
        fr: 'FR',
        en: 'EN',
        es: 'ES',
    },
	price:{
		priceType:{
			fixed: 'fixed',
			variable: 'variable',
		}
	},
    group: {
        for: { // Model Group.php
            vehicle: 'vehicle',
            storage: 'storage',
            marina: 'marina',
            workspace: 'workspace',
            passerby: 'passerby',
            garagebox: 'garagebox',
            parking: 'parking',
            house: 'house',
            boot_motor: 'boot-motor',
            service: 'service',
        },
    },
    type: {
      book_place_prefer:{
          yes: 'yes',
          yes_map: 'yes_map',
      },
    },
    typeInfo: {
        id: {
            caravan: 1,
            camper: 2,
            folding_trailer: 3,
            car: 4,
            boats: 5,
            trailer: 6,
            oldtimer: 7,
            storage: 8,
            motorbike: 9,
            workspaces: 10,
            marina: 11,
            garagebox: 12,
            office: 17,
            watercraft: 18,
            bootmotor: 19,
        },
        isVehicleOrMarina(id){ // Include marina!
           return [1,2,3,4,5,6,7,9,11,18].includes(id);
        },
        isBootOrMarina(id){
           return [5,11].includes(id);
        },
        idToName(id){
            let list = {
                1: 'Caravan',
                2: 'Camper',
                3: 'Vouwwagen',
                4: 'Auto',
                5: 'Boot',
                6: 'Aanhanger',
                7: 'Oldtimer',
                9: 'Motor',
                11: 'Jachthaven',
                18: 'Waterscooter',
            };
            return list[id];
        },
    },
    user: {
        accountType: {
            private: 'private',
            receiver: 'receiver',
        }
    },
    package: {
        stopOption: {
            ticket: 'ticket',
            instruction: 'instruction',
        }
    },
    ticket: {
        reason: {
            other: 0,
            not_needed: 1,
            switch: 2,
            sold: 3,
            wrong_size: 4,
            elsewhere: 5,
            unsatisfied: 6,
            bad_price: 7,
        }
    },
    appointment:{
        type:{
            bring_loc: 'bring-loc',
            pickup_loc: 'pickup-loc',
            workshop: 'workshop',
        },
    },
    exportOption:{
        source: {
            invoice: 'invoice',
            place: 'place',
            article: 'article',
            vehicle: 'vehicle',
            invoice_open_post: 'invoice_open_post',
            invoice_deposits: 'invoice_deposits',
            user_note: 'user_note',
            reservation_from: 'reservation_from',
            chats: 'chats',
            passerby: 'passerby',
            appointment: 'appointment',
            lead: 'lead',
            reservation: 'reservation',
            product: 'product',
            relay_log: 'relay_log',
            task: 'task',
            vehicle_log: 'vehicle_log',
            meter_log: 'meter_log',
            reservation_feedback: 'reservation_feedback',
        }
    },
    article: {
        type:{
            normal: 'normal',
            service: 'service',
            member: 'member',
            rent: 'rent',
            insurance: 'insurance',
        },
        boxState:{
            no: 'no',
            yes: 'yes',
            yes_required: 'yes_required',
        }
    },
    passerbyInfo: {
        priceType:{
            fixed: 'fixed',
            variable: 'variable',
        }
    },
    product: {
        frequency: {
            one_time: 'eenmalig',
            month: 'per maand',
            half_year: 'per half jaar',
            quarter: 'per kwartaal',
            year: 'per jaar',
        }
    },
	reservation: {
		closeSettlement: {
			no: 'no',
			restore: 'restore',
			partial_credit: 'partial_credit',
			final_settlement: 'final_settlement',
			delete: 'delete',
		}
	},
	invoice: {
		bundle: {
			normal: 'normal',
			broken: 'broken',
		},
	},

	// enumList.loPath(this.state.locationId) + '/api
	loPath(locationId){
		return '/lo' + locationId;
	}
};

function faqStructToggle(base) {
	var root = base.parentElement;
	var statusOpen = root.classList.contains('active');
	var allRoots = document.querySelectorAll('.faq-struct > div');
	view.removeClass(allRoots, 'active');

	if(!statusOpen){
		root.classList.add('active');
	}

	return false;
}

// FAQ toggle
function faqToggle(base) {
	var elementAnswer = base.parentNode.getElementsByTagName('div')[0];
	var elementAnswers = document.getElementsByClassName('faq-answer');
	var elementArrows = document.getElementsByClassName('faq-question');
	var statusOpen = (elementAnswer.style.display === 'none') ? false : true;

	// Close all faq-answer
	for(i = 0; i < elementAnswers.length; i++) {
		elementAnswers[i].style.display = "none";
	}

	// Reset all arrows
	for(i = 0; i < elementArrows.length; i++) {
		elementArrows[i].classList.remove('faq-line-icon-down');
	}

	if(statusOpen)
		elementAnswer.style.display = "none";
	else {
		base.classList.add('faq-line-icon-down');
		elementAnswer.style.display = "block";
	}
	return false;
}

var formatHelper = {
	volumeToNl: function (volume){
		if(volume){
			return volume.replace('.',',');
		}
		return volume;
	}
}

let inputDateForState = {
	transform(ob, val) {
		if (ob.type !== 'date') {
			if (val && val.indexOf("-") === 4) {
				return this.dateToNl(val);
			}
		}
		return val;
	},
	inputToDate(str){
		if(str.indexOf("-") === 4){ // EN
			return new Date(str);
		}
		else{
			return this.nlToDate(str);
		}
	},
	dateToInput(ob, date){
		if(ob.type === 'date' ){ // Safari
			return this.dateToEn(date);
		}
		else{
			return this.dateToNl(date);
		}
	},
	dateToNl(str) {
		let date = new Date(str);
		let day = date.getDate(),
			month = date.getMonth() + 1,
			year = date.getFullYear();

		day = day < 10 ? '0' + day : day ;
		month = month < 10 ? '0' + month : month ;
		return day + '-' + month + '-' + year;
	},
	dateToNlLocal(str){
		let date = new Date(str);
		return date.toLocaleDateString("nl-NL", {day:"numeric", month:"short", year:"numeric"});
	},
	dateToEn(d){
		let	month = '' + (d.getMonth() + 1),
			day = '' + d.getDate(),
			year = d.getFullYear();

		if (month.length < 2)
			month = '0' + month;
		if (day.length < 2)
			day = '0' + day;

		return [year, month, day].join('-');
	},
	nlToDate(str){
		let split = str.split('-');
		let day = parseInt(split[0]),
			month = parseInt(split[1]),
			year = parseInt(split[2]);
		return new Date(year, month - 1, day);
	},
	daysInYear(yearInt) {
		return (yearInt % 400 === 0 || (yearInt % 100 !== 0 && yearInt % 4 === 0)) ? 366 : 365;
	},
	diffInDay(d1, d2){
		// Remove time
		d1 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate());
		d2 = new Date(d2.getFullYear(), d2.getMonth(), d2.getDate());
		return Math.floor((d2 - d1) / (1000 * 60 * 60 * 24));
	}
}

// Fix no input date support
let inputDateElements = document.getElementsByClassName('form-date');
for (let i=0; i<inputDateElements.length; i++) {
	let el = inputDateElements[i];
	if(el.type !== 'date' && el.type !== 'datetime-local'){
		if(el.value !== "" ) {
			let val = el.value;
			if (val && val.indexOf("-") === 4) {
				el.value = inputDateForState.dateToNl(val);
			}
		}
		if(!el.pattern){
			el.pattern = "(0[1-9]|1[0-9]|2[0-9]|3[01])-(0[1-9]|1[012])-[0-9]{4}";
		}
	}
	else if(!el.classList.contains('form-date-no-reset')){
		// Add wis button
		let btn = document.createElement('a');
		btn.classList.add('form-date-reset')
		btn.addEventListener('click', function (e) {
			el.value = '';
			el.setAttribute('value', ''); // Needed special treatment for safari
			el.dispatchEvent(new Event('input'));
			el.dispatchEvent(new Event('change'));
		});
		el.parentElement.appendChild(btn);
	}
}

// Fix no input date support
var inputTimeElements = document.getElementsByClassName('form-time');
for (var i=0; i<inputTimeElements.length; i++) {
	var inputTimeElement = inputTimeElements[i];
	if(inputTimeElement.type !== 'time' ){
		if(!inputTimeElement.pattern){
			inputTimeElement.pattern = "([01][0-9]|2[0-3]):[0-5][0-9]";
		}
	}
}

/* menu */
var menuBar = {
	// Element
	menuElements: document.getElementsByClassName('menu-item'),

	// State
	menuState: false,

	// Functions
	toggle: function () {
		this.menuState = !this.menuState;
		this.render();
	},
	open: function () {
		this.menuState = true;
		this.render();
	},
	close: function () {
		this.menuState = false;
		this.render();
	},

	OnlyClose: function(){
		if (this.menuState){
			this.close();
		}
	},

	// Render
	render:function () {
		this.renderMenu();
	},

	renderMenu: function () {
		for (var i in this.menuElements){
			if (this.menuElements.hasOwnProperty(i)){
				this.menuElements[i].style.display = this.menuState ? 'block' : 'none';
			}
		}
	},
}

let offerFilter = {
    state: {
        typeInfoId: null,
    },
    init(typeInfoId){
        this.state.typeInfoId = typeInfoId;
    },
    resetFilter(filter) {
        gtag('event', 'click-offer-reset-filter-' + filter);
        if(filter === 'price-from'){
            document.getElementById('filter-price-from').value = '';
        }
        if(filter === 'price-to'){
            document.getElementById('filter-price-to').value = '';
        }
        if(filter === 'distance'){
            document.getElementById('filter-distance').selectedIndex = 0;
        }
        if(filter === 'washing'){
            document.getElementById('filter-has-wash').checked = false;
        }
        if(filter === 'repair'){
            document.getElementById('filter-has-repair').checked = false;
        }
        if(filter === 'power'){
            document.getElementById('filter-has-power').checked = false;
        }
        if(filter === 'self-service'){
            document.getElementById('filter-has-self-service').checked = false;
        }
        if(filter === 'delivery-service'){
            document.getElementById('filter-has-delivery-service').checked = false;
        }
        if(filter === 'frost-free'){
            document.getElementById('filter-has-frost-free').checked = false;
        }
        if(filter === 'area-type'){
            document.getElementById('filter-area-type').selectedIndex = 0;
        }
        if(filter === 'ground-type'){
            document.getElementById('filter-ground-type').selectedIndex = 0;
        }
        if(filter === 'company-type'){
            document.getElementById('filter-company-type').selectedIndex = 0;
        }
        if(filter === 'volume-min'){
            document.getElementById('filter-volume-min').value = 0;
        }
        if(filter === 'volume-max'){
            document.getElementById('filter-volume-max').value = 0;
        }
        if(filter === 'square-min'){
            document.getElementById('filter-square-min').value = 0;
        }
        if(filter === 'square-max'){
            document.getElementById('filter-square-max').value = 0;
        }
        if(filter === 'volume-selection'){
            document.getElementById('filter-volume-selection').selectedIndex = 0;
        }
        if(filter == 'winter'){
            document.getElementById('filter-winter').checked = false;
        }
        if(filter === 'year-price'){
            document.getElementById('filter-year-price').checked = false;
        }
        this.updateFilter();
    },
    orderFilter(element) {
        gtag('event', 'click-offer-order-filter-' + element.innerHTML);
        let holder = document.getElementById('offer-order-holder');

        if(holder.getAttribute('data-order-by') === element.innerHTML){
            this.orderFilterToggle();
        }
        else{
            if(element.innerHTML === 'afstand'){
                holder.setAttribute('data-order-by', 'afstand');
            }
            else if(element.innerHTML === 'prijs'){
                holder.setAttribute('data-order-by', 'prijs');
            }
            else{
                holder.setAttribute('data-order', '');
                holder.setAttribute('data-order-by', '');
            }
        }
        this.updateFilter();
    },
    orderFilterToggle() {
        let holder = document.getElementById('offer-order-holder');
        let orderValue = holder.getAttribute('data-order');

        if(orderValue === 'desc'){
            holder.setAttribute('data-order', 'asc');
        }
        else {
            holder.setAttribute('data-order', 'desc');
        }
    },
    updateFilter(ob) {
        if(typeof ob === "object"){
            let obIdName = null;
            if(ob.id){
                obIdName = ob.id;
            }
            if(ob.getAttribute('data-a-name')){
                obIdName = ob.getAttribute('data-a-name');
            }
            if(obIdName){
                gtag('event', 'click-offer-filter-' + obIdName);
            }
        }

        let holderOrderBy = document.getElementById('offer-order-holder').getAttribute('data-order-by');
        let holderOrder = document.getElementById('offer-order-holder').getAttribute('data-order');

        let filterPriceFromValue = parseInt(document.getElementById('filter-price-from').value);
        let filterPriceToValue = parseInt(document.getElementById('filter-price-to').value);
        let filterVolumeMin = document.getElementById('filter-volume-min');
        let filterVolumeMax = document.getElementById('filter-volume-max');
        let filterVolumeSelection = document.getElementById('filter-volume-selection');
        let filterSquareMin = document.getElementById('filter-square-min');
        let filterSquareMax = document.getElementById('filter-square-max');
        let filterSquareSelection = document.getElementById('filter-square-selection');

        let filterLengthElement = document.getElementById('filter-l');
        let filterWidthElement = document.getElementById('filter-w');
        let filterDistanceElement = document.getElementById('filter-distance');
        let filterAreaType = document.getElementById('filter-area-type');
        let filterGroundType = document.getElementById('filter-ground-type');
        let filterCompanyType = document.getElementById('filter-company-type');

        let filterWashing = document.getElementById('filter-has-wash');
        let filterHasRepair = document.getElementById('filter-has-repair');
        let filterHasPower = document.getElementById('filter-has-power');
        let filterHasSelfService = document.getElementById('filter-has-self-service');
        let filterHasDeliveryService = document.getElementById('filter-has-delivery-service');
        let filterHasFrostFree = document.getElementById('filter-has-frost-free');
        let filterWinter = document.getElementById('filter-winter');
        let filterYearPrice = document.getElementById('filter-year-price');

        let url = location.protocol + '//' + location.host + location.pathname;
        let searchQuery = [];

        if(filterPriceFromValue && filterPriceFromValue > 0 ){
            searchQuery.push('prijs-van=' + filterPriceFromValue);
        }
        if(filterPriceToValue && filterPriceToValue > 0 && (filterPriceFromValue && filterPriceToValue > filterPriceFromValue || !filterPriceFromValue) ){
            searchQuery.push('prijs-tot=' + filterPriceToValue);
        }

        if(filterVolumeSelection && filterVolumeSelection.value){
            let filterVolumePart = filterVolumeSelection.value.split('-');
            searchQuery.push('volume-van=' + filterVolumePart[0]);
            searchQuery.push('volume-tot=' + filterVolumePart[1]);
        }
        else {
            if(filterVolumeMin && filterVolumeMin.value){
                searchQuery.push('volume-van=' + parseInt(filterVolumeMin.value));
            }
            if(filterVolumeMax && filterVolumeMax.value){
                searchQuery.push('volume-tot=' + parseInt(filterVolumeMax.value));
            }
        }

        if(filterSquareSelection && filterSquareSelection.value){
            let filterSquarePart = filterSquareSelection.value.split('-');
            searchQuery.push('oppervlakte-van=' + filterSquarePart[0]);
            searchQuery.push('oppervlakte-tot=' + filterSquarePart[1]);
        }
        else {
            if(filterSquareMin && filterSquareMin.value){
                searchQuery.push('oppervlakte-van=' + parseInt(filterSquareMin.value));
            }
            if(filterSquareMax && filterSquareMax.value){
                searchQuery.push('oppervlakte-tot=' + parseInt(filterSquareMax.value));
            }
        }

        if(filterLengthElement && filterLengthElement.value && filterLengthElement.getAttribute('data-default-value') !== filterLengthElement.value) {
            searchQuery.push('l=' + filterLengthElement.value);
        }
        if(filterWidthElement && filterWidthElement.value && filterWidthElement.getAttribute('data-default-value') !== filterWidthElement.value) {
            searchQuery.push('b=' + filterWidthElement.value);
        }
        if(filterDistanceElement && filterDistanceElement.value){
            searchQuery.push('afstand=' + filterDistanceElement.value);
        }
        if(filterWashing && filterWashing.checked){
            searchQuery.push('wassen=ja');
        }
        if(filterHasRepair && filterHasRepair.checked){
            searchQuery.push('onderhoud=ja');
        }
        if(filterHasPower && filterHasPower.checked){
            searchQuery.push('stroom=ja');
        }
        if(filterHasPower && filterHasSelfService.checked){
            searchQuery.push('self-service=ja');
        }
        if(filterHasDeliveryService && filterHasDeliveryService.checked){
            searchQuery.push('haal-breng-service=ja');
        }
        if(filterHasFrostFree && filterHasFrostFree.checked){
            searchQuery.push('vorstvrij=ja');
        }
        if(filterWinter && filterWinter.checked){
            searchQuery.push('winter=ja');
        }
        if(filterYearPrice){
            searchQuery.push('jaar-prijs=' + (filterYearPrice.checked ? 'ja' : 'nee'));
        }
        if(filterAreaType && filterAreaType.value){
            searchQuery.push('gebied=' + filterAreaType.value);
        }
        if(filterGroundType && filterGroundType.value){
            searchQuery.push('ondergrond=' + filterGroundType.value);
        }
        if(filterCompanyType && filterCompanyType.value){
            searchQuery.push('bedrijfstype=' + filterCompanyType.value);
        }
        if(holderOrderBy && holderOrderBy === 'prijs'){
            searchQuery.push('order-op=' + holderOrderBy);
        }
        if(holderOrder && holderOrder !== 'asc'){
            searchQuery.push('order=' + holderOrder);
        }
        if(searchQuery.length) {
            url = url + '?' + searchQuery.join('&');
        }

        // Set size
        if(filterLengthElement){
            localStorage.setItem("visitor-object-l-" + this.state.typeInfoId, filterLengthElement.value);
        }
        if(filterWidthElement){
            localStorage.setItem("visitor-object-w-" + this.state.typeInfoId, filterWidthElement.value);
        }

        window.location.href = url;
    }
}
const onAction = {
	init(){
		if(!this.activeForPage()){
			return;
		}
		this.setListener();
	},
	activeForPage(){
		let p = document.location.pathname
		return (p === '/' || p.startsWith('/aanbod'));
	},
	setListener(){
		document.body.addEventListener('keydown', this.keyDown.bind(this));
	},
	keyDown(e){
		if(e.target !== document.body){
			return;
		}
		if(e.key === '?' && e.shiftKey && cacheUserNameHelper.isLogin()){
			document.location.href= cacheUserNameHelper.getPathToDashboard();
		}
	}
}
onAction.init();
oneSubmit = {
	element: {
		forms: document.querySelectorAll("form"),
	},

	state:{
		setLock: false,
		lockSubmit: true,
	},

	// Functions
	init: function(){
	 	this.onSubmit();
	},

	// Action
	onSubmit: function () {
	 	var formElements = this.element.forms;
		for(var x=0; x < formElements.length; x++) {
			formElements[x].addEventListener("submit", function (event) {
				var formElementSubmits = this.querySelectorAll("input[type='submit']:not(.skip-one-submit)");
				var o = oneSubmit;
				for(var x=0; x < formElementSubmits.length; x++) {
					if(!o.state.setLock){
						formElementSubmits[x].setAttribute('data-restore-value',  formElementSubmits[x].value);
						formElementSubmits[x].addEventListener('click', function(evt) {
							if(oneSubmit.state.lockSubmit){
								console.log("skip click");
								evt.preventDefault();
								return false;
							}
						});
					}
					// .disabled = true; // Not work for multi buttons
					formElementSubmits[x].classList.add('btn-disabled');
					formElementSubmits[x].value = "Verwerken...";
				}
				o.state.setLock = true;
				o.state.lockSubmit = true;
			})
		}
	},

	restore: function () {
		this.state.lockSubmit = false;
		var formElements = this.element.forms;
		for(var x=0; x < formElements.length; x++) {
			var formElementSubmits = document.querySelectorAll("input[type='submit']");
			for(var x=0; x < formElementSubmits.length; x++) {
				formElementSubmits[x].classList.remove('btn-disabled');
				formElementSubmits[x].value = formElementSubmits[x].getAttribute('data-restore-value');
			}
		}
	}
};
oneSubmit.init();

const panel = {
	idToOb(id) {
		return document.getElementById(id);
	},
	show(ob) {
		if (ob) {
			ob.style.display = '';
		}
	},
	hide(ob, skipMissing) {
		if (ob) {
			ob.style.display = 'none';
		} else if (!skipMissing) {
			console.debug('panel missing', ob)
		}
	},
	set(ob, show) {
		if (show) {
			return this.show(ob);
		}
		return this.hide(ob);
	},
	requiredChange(ob, action) {
		if (ob) {
			ob.required = action;
		}
	},
}
let panelClass = {
	show(ob) {
		if (!ob.classList.contains('show')) {
			ob.classList.add('show');
		}
	},
	hide(ob, skipMissing) {
		if (ob.classList.contains('show')) {
			ob.classList.remove('show');
		}
	},
	toggle(ob) {
		ob.classList.toggle('show');
	},
}

const priceHelper = {
	priceTypeFixed: 'fixed',
	priceTypeVariable: 'variable',
	priceTypeVariableM2: 'variable-m2',
	fromCentToNl(cent, allowNullReturn){
		return this.toNl(cent/100, allowNullReturn);
	},

	toNl(prise, allowNullReturn){
		if(!prise || prise == 0){
			if(allowNullReturn){
				return null;
			}
			return 0.00
		}
		if(typeof prise === 'string'){
			prise = parseFloat(prise.replace(",", "."))
		}
		if(typeof prise === 'number'){
			return prise.toFixed(2).replace(".", ",");
		}

		return null
	},
	centToEuroLongNl(price_int){ // e.q.: 1.000,00
		if(!price_int){
			return '-';
		}
		return new Intl.NumberFormat("nl-NL", {
			style: "currency",
			currency: "EUR",
			minimumFractionDigits: 0
		}).format(price_int / 100);
	},
	centToLongNl(price_int){ // e.q.: 1.000,00
		if(!price_int){
			return '-';
		}
		return new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" }).format(price_int / 100);
	},
	toFloat(prise) {
		if(typeof prise === 'string'){
			prise = prise.replace(".", ""); // Remove dot
			prise = parseFloat(prise.replace(",", "."));
		}
		if(typeof prise === 'number'){
			return prise.toFixed(2);
		}
	}
}

const pricingSlider = {
    init() {
        const pricingSliders = document.querySelectorAll(".pricing-slider");
        if (pricingSliders.length > 0) {
            for (let i = 0; i < pricingSliders.length; i++) {
                const pricingSlider = pricingSliders[i];
                const pricingInput = {
                    el: pricingSlider.querySelector("input")
                };
                pricingInput.data = JSON.parse(
                    pricingInput.el.getAttribute("data-price-input")
                );
                pricingInput.currentValEl = pricingSlider.querySelector(".pricing-slider-value");
                const pricingSection = pricingSlider.closest(".pricing-v2, .pricing-slider-section, section");
                const billingToggle = pricingSection ? pricingSection.querySelector("#billing-toggle") : null;
                const pricingOutputEls = pricingSection.querySelectorAll(".pricing-item-price");
                const pricingOutput = [];
                for (let i = 0; i < pricingOutputEls.length; i++) {
                    const pricingOutputEl = pricingOutputEls[i];
                    const pricingOutputObj = {};
                    pricingOutputObj.el = pricingOutputEl;
                    pricingOutputObj.currency = pricingOutputEl.querySelector(".pricing-item-price-currency");
                    pricingOutputObj.amount = pricingOutputEl.querySelector(".pricing-item-price-amount");
                    pricingOutputObj.after = pricingOutputEl.querySelector(".pricing-item-price-after");
                    pricingOutput.push(pricingOutputObj);
                }

                pricingInput.el.setAttribute("min", 0);
                pricingInput.el.setAttribute("max", Object.keys(pricingInput.data).length - 1);
                !pricingInput.el.getAttribute("value") &&
                pricingInput.el.setAttribute("value", 0);

                handlePricingSlider(pricingInput, pricingOutput, billingToggle, pricingSection);
                pricingInput.el.addEventListener("input", function () {
                    handlePricingSlider(pricingInput, pricingOutput, billingToggle, pricingSection);
                });

                if (billingToggle) {
                    billingToggle.addEventListener("change", function () {
                        handlePricingSlider(pricingInput, pricingOutput, billingToggle, pricingSection);
                    });
                }
            }
        }

        function handlePricingSlider(input, output, billingToggle, pricingSection) {
            const isYearly = billingToggle ? billingToggle.checked : false;
            const activeMode = isYearly ? "yearly" : "monthly";

            input.currentValEl.innerHTML = input.data[input.el.value];

            for (let i = 0; i < output.length; i++) {
                const outputObj = output[i];

                const dataAttr = isYearly
                    ? outputObj.el.getAttribute("data-price-output-yearly") ||
                    outputObj.el.getAttribute("data-price-output-monthly") ||
                    outputObj.el.getAttribute("data-price-output")
                    : outputObj.el.getAttribute("data-price-output-monthly") ||
                    outputObj.el.getAttribute("data-price-output");

                outputObj.data = JSON.parse(dataAttr);

                if (outputObj.currency) {
                    outputObj.currency.innerHTML = outputObj.data[input.el.value][0];
                }
                if (outputObj.amount) {
                    outputObj.amount.innerHTML = outputObj.data[input.el.value][1];
                }
                if (outputObj.after) {
                    outputObj.after.innerHTML = outputObj.data[input.el.value][2];
                }
            }

            if (pricingSection) {
                pricingSection.querySelectorAll("[data-billing-label]").forEach(label => {
                    label.classList.toggle("active", label.getAttribute("data-billing-label") === activeMode);
                });

                pricingSection.querySelectorAll(".table-price-monthly").forEach(el => {
                    el.style.display = isYearly ? "none" : "";
                });

                pricingSection.querySelectorAll(".table-price-yearly").forEach(el => {
                    el.style.display = isYearly ? "" : "none";
                });
            }
        }
    }
};

for (let e of document.querySelectorAll('input[type="range"].slider-progress')) {
    e.style.setProperty('--value', e.value);
    e.style.setProperty('--min', e.min == '' ? '0' : e.min);
    e.style.setProperty('--max', e.max == '' ? '9' : e.max);
    e.addEventListener('input', () => e.style.setProperty('--value', e.value));
}
// var processGraphs = document.querySelectorAll('.process polygon');
// var processDetails = document.querySelectorAll('.process-details > div');
// var processGraphMouseover = function (event) {
//     for (var pg = 0, pgl = processGraphs.length; pg < pgl; pg++) {
//         if (processGraphs[pg] === event.target && event.type === 'mouseover') {
//             processGraphs[pg].style.opacity = 1;
//         } else {
//             processGraphs[pg].style.opacity = 0.5;
//         }
//     }
//     for (pd = 0, pdl = processDetails.length; pd < pdl; pd++) {
//         if (processDetails[pd].classList.contains(event.target.getAttribute('class')) && event.type === 'mouseover') {
//             processDetails[pd].style.opacity = 1;
//         } else {
//             processDetails[pd].style.opacity = 0.5;
//         }
//     }
// };
// var processGraphMouseout = function (event) {
//     for (var pg = 0, pgl = processGraphs.length; pg < pgl; pg++) {
//         processGraphs[pg].removeAttribute('style');
//     }
//     for (pd = 0, pdl = processDetails.length; pd < pdl; pd++) {
//         processDetails[pd].removeAttribute('style');
//     }
// };
// for (var pg = 0, pgl = processGraphs.length; pg < pgl; pg++) {
//     processGraphs[pg].addEventListener('mouseover', processGraphMouseover);
//     processGraphs[pg].addEventListener('mouseout', processGraphMouseout);
// }
let reqHelper = {
    debug: false,
    getJson(url, callback, delay, currentReq) {
        return this.get(url, async function (r) {
            callback(await r.json());
        }, delay, currentReq);
    },
    get(url, callback, delay, currentReq) {
        let abortController = new AbortController();
        // Make request function
        let request = new Request(url, {
            method: "get",
            signal: abortController.signal,
        });

        return this.call(request, callback, delay, currentReq, abortController)
    },

    call(request, callback, delay, currentReq, abortController) {
        // Abort request in progress
        if (currentReq && currentReq.abortController) {
            if (this.debug) {
                console.log('REQ: abort', currentReq);
            }
            currentReq.abortController.abort('new request');
        }

        let makeRequest = () => {
            fetch(request)
                .then(r => {
                    if (callback) {
                        callback(r);
                    }
                })
                .catch(error => {
                    console.log('REQ err:', error);
                });
        }

        let delayTimer = null;
        // Delay timer
        if (delay) {
            if (currentReq && currentReq.delayTimer) {
                if (this.debug) {
                    console.log('REQ: delay stop prerivius');
                }
                clearTimeout(currentReq.delayTimer);
            }
            delayTimer = setTimeout(makeRequest.bind(this), delay);
        } else { // No delay
            makeRequest();
        }
        return {
            delayTimer: delayTimer,
            abortController: abortController,
            request: request,
        }
    },
};
let requestHelper = {
	getJson: function (link, update) {
		let xHttp = this.get(link, update);
		if(!xHttp){
			return;
		}
		try {
			return JSON.parse(xHttp.responseText)
		} catch (e) {
			console.error('request or json failed', xHttp.responseURL, e);
			return;
		}
	},

	get: function(link, update){
		let xHttp = this.do(link, update, false);
		console.debug("request: ", link, xHttp.status);
		if(xHttp.status != 200){
			return null;
		}
		return xHttp;
	},

	do: function (link, update, async) {
		if (!link) {
			return
		}
		let xHttp = new XMLHttpRequest();
		xHttp.onreadystatechange = update;
		xHttp.open("GET", link, async);
		if (window._language !== undefined) {
			xHttp.setRequestHeader("X-Accept-Language", language().getLanguageCode());
		}
		xHttp.send();
		return xHttp;
	},

	post: function (link, json, update, async, csrf) {
		if (!link) {
			return
		}
		let xHttp = new XMLHttpRequest();
		xHttp.onreadystatechange = update;
		xHttp.open("POST", link, async);
		xHttp.setRequestHeader("Content-Type", "application/json");

		if (window._language !== undefined) {
			xHttp.setRequestHeader("X-Accept-Language", language().getLanguageCode());
		}
		if(csrf){
			xHttp.setRequestHeader("X-CSRF-TOKEN", csrf);
		}
		xHttp.send(json);
		console.debug("request post: ", link, xHttp.status);
		return xHttp;
	},
	getOb: function (url){
		return {
			url: url,
			data: this.getJson(url)
		};
	},

	// New version
	async getFetchJson (url) {
		let config = {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
		}
		if (window._language !== undefined) {
			config.headers['X-Accept-Language'] = language().getLanguageCode();
		}
		const response = await fetch(url, config);
		return await response.json();
	},

	async getFetchJsonOb (url) {
		const response = await fetch(url);
		return {
			response: response,
			json: await response.json()
		};
	},

	async postFetch (csrf, url, data) {
		let config = {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'X-CSRF-TOKEN': csrf,
			},
			body: JSON.stringify(data)
		}
		if (window._language !== undefined) {
			config.headers['X-Accept-Language'] = language().getLanguageCode();
		}
		return await fetch(url, config);
	},
};


var scrollAction = {
	set: function (id, y) {
		window.addEventListener('scroll', function(e) {
			var el = document.getElementById(id);
			if(window.scrollY > y){
				el.classList.add('show');
			}
			else {
				el.classList.remove('show');
			}
		});
	}
}

let selectHelper = {
	removeAll(ob) {
		while (ob.options.length) ob.remove(0);
	},

	add(ob, value, text, selected, disable, translated){
		let option = document.createElement("option");
		option.value = value;
		if (translated) {
			option.dataset.trans = text;
		}
		else {
			option.text = text;
		}
		if(disable){
			option.disabled = true;
		}
		if(selected){
			option.selected = 'selected';
		}
		ob.add(option);
	},
	selectedByValue(ob, value) {
		var selectOptions = ob.options;
		//Loop through these options using a for loop.
		for (var opt, j = 0; opt = selectOptions[j]; j++) {
			//If the option of value is equal to the option we want to select.
			if (opt.value == value) {
				//Select the option and break out of the for loop.
				ob.selectedIndex = j;
				break;
			}
		}
	},
	onchangeGEvent:function (el, name) {
		let val = el.value;
		gtag('event', 'onchange-' + name + '-' + val);
	}
}

let showSlide = {
	el:{
		closeBtn: document.getElementById('btn-close'),
		container360: document.getElementById('container360'),
		fotoShow: document.getElementById('foto-show'),
		inSlide:{
			photo: document.getElementById('slide-in-open-photo'),
			b360: document.getElementById('slide-in-open-360'),
			video: document.getElementById('slide-in-open-video'),
		},
		photo:{
			previous: document.getElementById('sheet-photo-previous'),
			next: document.getElementById('sheet-photo-next'),
		},
		b360:{
			container: document.getElementById('container360'),
		},
		btnBar:{
			photo: document.getElementById('slide-open-photo'),
			b360: document.getElementById('slide-open-360'),
			video: document.getElementById('slide-open-video'),
		}
	},
	config:{
		swipeOffset: 100,
	},
	state:{
		show: false,
		photoIndex: 0,
		type: null,
		b360ImageList: [],
		b360ImageUrl: '',
	},

	init(){
		this.setListener();
	},
	setListener(){
		this.el.closeBtn.addEventListener('click', this.actionClose.bind(this))
		document.addEventListener('keydown', this.actionKeyDown.bind(this))

		if(this.el.photo.previous && this.el.photo.next){
			this.el.photo.previous.addEventListener('click', this.actionPushSlide.bind(this, -1));
			this.el.photo.next.addEventListener('click', this.actionPushSlide.bind(this, 1));
		}
		if(this.el.btnBar.photo){
			this.el.btnBar.photo.addEventListener('click', this.actionOpen.bind(this, 'photo', 0));
		}
		if(this.el.btnBar.b360){
			this.el.btnBar.b360.addEventListener('click', this.actionOpen.bind(this, '360', 1));
		}
		if(this.el.btnBar.video){
			this.el.btnBar.video.addEventListener('click', this.actionOpen.bind(this, 'video', 0));
		}
		if(this.el.inSlide.photo){
			this.el.inSlide.photo.addEventListener('click', this.actionOpen.bind(this, 'photo', 0));
		}
		if(this.el.inSlide.b360){
			this.el.inSlide.b360.addEventListener('click', this.actionOpen.bind(this, '360', 0));
		}
		if(this.el.inSlide.video){
			this.el.inSlide.video.addEventListener('click', this.actionOpen.bind(this, 'video', 0));
		}

		let previewPhotoList = document.querySelectorAll('.offer-show-limit img');
		for(let i = 0; i < previewPhotoList.length; i++) {
			let el = previewPhotoList[i];
			el.addEventListener('click', this.actionOpen.bind(this, 'photo', i));
		}
		// Photo buttons
		let btnNrPhotoList = document.querySelectorAll('#sheet-photo .slide-show-box-btn .btn-nav-choose');
		for(let i = 0; i < btnNrPhotoList.length; i++) {
			let el = btnNrPhotoList[i];
			el.addEventListener('click', this.actionOpen.bind(this, 'photo', i));
		}
		let btnNr360List = document.querySelectorAll('#sheet-360 .slide-show-box-btn .btn-nav-choose');
		for(let i = 0; i < btnNr360List.length; i++) {
			let el = btnNr360List[i];
			el.addEventListener('click', this.actionOpen.bind(this, '360', i));
		}

		// Swipe
		let swipeOb = document.getElementById('slide-show-swipe');
		let touchstartX = 0;
		swipeOb.addEventListener('touchstart', ev => {touchstartX = ev.changedTouches[0].screenX});
		swipeOb.addEventListener('touchend', function (ev) {
			let touchendX = ev.changedTouches[0].screenX
			let diff = touchstartX - touchendX;
			if (Math.abs(diff) > this.config.swipeOffset) {
				this.actionPushSlide(diff > 0 ? 1 : -1);
			}
		}.bind(this))
	},
	actionKeyDown(e){
		if(!this.state.type){
			return;
		}
		if (e.key === 'ArrowLeft') {
			this.actionPushSlide(-1);
		}
		if (e.key === 'ArrowRight') {
			this.actionPushSlide(1);
		}
		if(e.key === 'Escape'){
			this.actionClose();
		}
	},
	actionOpen(name, index){
		this.stopYoutube();
		panel.show(this.el.fotoShow);
		this.el.fotoShow.style.display = 'block';
		this.renderSlideBox(name, index);
		document.body.style.position = 'fixed';
		this.state.type = name;
	},
	actionClose(){
		this.el.container360.innerHTML = '';
		this.el.fotoShow.style.display = 'none';
		this.stopYoutube();
		document.body.style.position = 'relative';
		this.state.type = null;
	},
	actionPushSlide(to){
		this.state.photoIndex += to;
		this.renderPhotoSlide();
	},

	stopYoutube() {
		if(this.state.type !== 'video'){
			return;
		}
		let x = document.querySelectorAll('.youtube-movie-item');
		for (let i = 0; i < x.length; i++) {
			x[i].src = x[i].src; // Trick to reload the iframe to stop playing
		}
	},

	renderSlideBox(name, index){
		this.state.photoIndex = index;
		let x = document.getElementsByClassName("slide-show-sheet");
		for (let i = 0; i < x.length; i++) {
			x[i].style.display = "none";
		}

		let s = document.getElementsByClassName("btn-nav-option");
		for (let i = 0; i < s.length; i++) {
			if(s[i].dataset.select === name){s[i].classList.add('active');}
			else {s[i].classList.remove('active')}
		}
		if(name === 'photo') {
			document.getElementById('sheet-photo').style.display = 'block';
			this.renderPhotoSlide();
		}
		if(name === '360') {
			document.getElementById('sheet-360').style.display = 'block';
			this.render360(index);
		}
		if(name === 'video') {
			document.getElementById('sheet-film').style.display = 'block';
		}

	},
	renderPhotoSlide(){
		let slideList = document.querySelectorAll('#sheet-photo .slide-item');
		let dots = document.querySelectorAll('#sheet-photo .btn-nav-choose');
		if (this.state.photoIndex >= slideList.length) {
			this.state.photoIndex = 0
		}
		if (this.state.photoIndex < 0) {
			this.state.photoIndex = slideList.length - 1;
		}

		for (let i = 0; i < slideList.length; i++) {
			slideList[i].style.display = "none";
		}

		// remove active
		dots.forEach(e => {e.classList.remove('active')});
		dots[this.state.photoIndex].classList.add("active");
		slideList[this.state.photoIndex].style.display = "block";
	},
	render360(number){
		number++;
		let slideList = document.querySelectorAll('#sheet-360 .slide-item');
		let dots = document.querySelectorAll('#sheet-360 .btn-nav-choose');

		let h = this.el.b360.container.clientHeight;
		let w = this.el.b360.container.clientWidth;
		this.el.b360.container.innerHTML = '';
		// Get info
		let imageInfo = this.state.b360ImageList[number];
		let yaw = imageInfo['start_point'] ? imageInfo['start_point'] : 0;

		let viewer = new Kaleidoscope.Image({
			source: this.state.b360ImageUrl + imageInfo['number'] + ".jpg",
			containerId: '#container360',
			height: h,
			width: w,
			initialYaw: yaw,
		});
		viewer.render();
		window.onresize = function() {
			h = this.el.b360.container.clientHeight;
			w = this.el.b360.container.clientWidth;
			viewer.setSize({height: h, width: w});
		}.bind(this);


		// Set button
		dots.forEach(e => {e.classList.remove('active')});
		dots[this.state.photoIndex].classList.add("active");
	},

}

const stringHelper = {
	UppercaseFirst(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	},
	nl2Br(str){
		if (!str){
			return '';
		}
		return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
	}
}

// tab opening hours system
tabOpeningHours = {
	currentSheetName: null,
	render: function(){
		// Sheets
		sheet = document.getElementById("tab-opening-sheet-" + this.currentSheetName);
		sheets = document.getElementsByClassName("tab-sheet");
		for (i = 0; i < sheets.length; i++) {
			sheets[i].style.display = "none";
		}
		if(sheet){
			sheet.style.display = "block";
		}

		menu = document.getElementById("tab-menu");
		if(!sheet || !menu){
			return;
		}

		// Buttons
		buttons = menu.children;
		for (i = 0; i < buttons.length; i++) {
			buttons[i].className = buttons[i].className.replace(" active", "");
			if(buttons[i].getAttribute('data-name') == this.currentSheetName){
				buttons[i].className = buttons[i].className += ' active';
			}
		}
	},
	open: function (nameOrType) {
		if(typeof nameOrType === "object"){
			this.currentSheetName = nameOrType.getAttribute('data-name');
		}
		else{
			this.currentSheetName = nameOrType;
		}
		gtag('event', 'click-type-tab-open-' + this.currentSheetName);
		this.render();
	},
	firstTime: function (name, failOver) {
		this.currentSheetName = name;
		if(!document.getElementById("tab-opening-sheet-a")){
			this.currentSheetName = failOver; // Fix for no self service
		}
		this.render();
	}
}
tabOpeningHours.firstTime('a', 'b');

var textCollapse = {

	actionClick: function(buttonOb){
		var parentOb = buttonOb.parentElement;
		if(!parentOb){
			console.log('textCollapse: parent object is missing', buttonOb);
			return;
		}
		var contentOb = parentOb.getElementsByClassName('text-collapse-content');
		if(contentOb && contentOb[0]){
			contentOb = contentOb[0];
		}

		var hasExpanded = contentOb.classList.contains('expanded');
		if(hasExpanded){
			contentOb.classList.remove('expanded');
			buttonOb.classList.remove('back');
		}
		else{
			contentOb.classList.add('expanded');
			buttonOb.classList.add('back');
		}

		return false;
	}
}

let tip = {
	init(){
		// Find all elements
		let els = document.querySelectorAll('[data-tip].tip');
		for(let i = 0; i < els.length; i++){
			let el = els[i];

			// Create info button
			let btnInfo = document.createElement('button');
			let btnClose = document.createElement('button');
			let elTip = document.createElement('div');

			// Btn
			btnInfo.type = 'button';
			btnInfo.classList.add('btn-no','btn-white-dark','btn-xs','fa','fa-info');
			btnInfo.addEventListener('click', panelClass.toggle.bind(this, elTip))
			//
			btnClose.type = 'button';
			btnClose.addEventListener('click', panelClass.hide.bind(this, elTip))
			btnClose.innerHTML = 'Sluit';

			//
			elTip.classList.add('tip-cont', 'below')
			elTip.innerHTML = el.getAttribute('data-tip');

			// Appent
			elTip.append(btnClose);
			el.append(btnInfo)
			el.append(elTip)
		}
	},
}
tip.init();

let toast = {
    el:{
        toast: document.createElement('div'),
    },
    state:{
        running: false,
        list: [],
    },
    init(){
        this._stuck();
    },
    info(text, time){this.show('info', text, time)},
    success(text, time){this.show('success', text, time)},
    warning(text, time){this.show('warning', text, time)},
    error(text, time){this.show('error', text, time)},
    show(type, text, time){
        this.state.list.push({
            type: type,
            time: time,
            text: text,
        });

        this._run();
    },
    _stuck(){
        this.el.toast.id = 'toast-msg';
        document.body.append(this.el.toast)
    },
    _run(){
        if(this.state.running){
            return;
        }
        this.state.running = true;
        let item = this.state.list.shift();
        if(!item){
            this.state.running = false;
            return;
        }

        // Show
        this.el.toast.classList.add('show');
        this.el.toast.classList.add(item.type);
        this.el.toast.innerHTML = item.text;

        let time = (item.time ? item.time : 4) * 1000;
        setTimeout(function (){
            // Close
            this.el.toast.classList.remove('show');
            this.el.toast.classList.remove(item.type);
            if(this.state.list.length !== 0){
                setTimeout(function (){
                    // Next
                    this.el.toast.style.display = '';
                    this.state.running = false;
                    this._run();
                }.bind(this), 500);
            } else{
                this.state.running = false;
            }
        }.bind(this), time);
    },
}
toast.init()

let jsCl = {
    toggle(id, classN){
        let e = document.getElementById(id);
        e.classList.toggle(classN);
    }
}
class Uploader {
	uploadHandler = null; // Closure returning promise
	progressBarEl = null;

	/**
	 * @param {HTMLElement} triggerButtonEl Element opening file selection, usually a button
	 * @param {HTMLElement} inputEl Input that temp. stores the file selection
	 * @param {HTMLElement} progressBarEl Progress bar element
	 * @param {callback} uploadHandler Closure returning a promise, upload function
	 * @param {callback} afterUploadHandler Closure function called after an upload is done
	 * @param {callback} afterUploadsHandler Closure function called after all uploads are done
	 */
	constructor(triggerButtonEl, inputEl, progressBarEl, uploadHandler, afterUploadHandler, afterUploadsHandler) {
		if (uploadHandler) {
			this.uploadHandler = uploadHandler;
		}
		else {
			throw new Error('No upload handler set.');
		}

		this.progressBarEl = progressBarEl;
		this.afterUploadHandler = afterUploadHandler;

		triggerButtonEl.addEventListener('click', () => {
			inputEl.click();
		});

		inputEl.addEventListener('change', (e) => {
			const files = Array.from(e.target.files);
			inputEl.value = ''; // reset

			this.uploadFiles(files).then(responses => {
				setTimeout(() => {
					if (afterUploadsHandler) {
						afterUploadsHandler(false, responses);
					}
				}, 200);
			}).catch(errors => {
				if (afterUploadsHandler) {
					afterUploadsHandler(errors.message, null);
				}
			}).finally(() => {
				// hide after all uploads were attempt
				setTimeout(() => {
					this.progressBarEl.classList.remove('show');
				}, 1000);
			});
		});
	}

	async uploadFiles(files) {
		const progressBar = this.progressBarEl;
		const progressEl = progressBar.querySelector('.progress');
		const statusEl = progressBar.querySelector('.status');
		let errors = ''

		progressEl.style.width = '0%';
		progressBar.classList.add('show');

		const total = files.length;
		statusEl.innerText = '0/' + total;

		if (!total) return;

		let completed = 0;

		for (const file of files) {
			try {
				let resizedFile = await ImageTools.resizeAndConvert(file, 2000, 2000).catch((err) => {
					console.warn('Could not resize file. Falling back to original. Error: ' + err.message);
					resizedFile = file
				});

				const response = await this.uploadHandler(resizedFile)

				if (!response.ok) {
					console.error('Failed to upload ' + file.name, response);
					errors += 'Fout ' + response.status + ': ' + file.name + ' kon niet geupload worden.'
				}
				else {
					if (this.afterUploadHandler) {
						this.afterUploadHandler(response);
					}
				}

				completed++;

				const progress = Math.round((completed / total) * 100);

				progressEl.style.width = progress + '%';
				statusEl.innerText = completed + '/' + total;
			} catch (error) {
				console.error('Failed to upload ' + file.name, error);
				errors += 'Fout: ' + file.name + ' kon niet geupload worden. '
			}
		}

		if (errors) {
			throw new Error(errors);
		}
	}
}

class ImageTools {
	static async resizeAndConvert(file, maxWidth, maxHeight, options = {}) {
		const {
			type = 'image/jpeg',
			quality = 1.0,
		} = options;

		const bitmap = await createImageBitmap(file);

		let width = bitmap.width;
		let height = bitmap.height;

		// preserve aspect ratio
		const ratio = Math.min(
			maxWidth / width,
			maxHeight / height,
			1 // prevent upscaling
		);

		width = Math.round(width * ratio);
		height = Math.round(height * ratio);

		const canvas = new OffscreenCanvas(width, height);
		const ctx = canvas.getContext('2d');

		ctx.drawImage(bitmap, 0, 0, width, height);

		const blob = await canvas.convertToBlob({
			type,
			quality,
		});

		bitmap.close?.();

		return new File(
			[blob],
			file.name,
			{ type }
		);
	}
}
var view = {
	show:function (el) {
		el.style.display = '';
	},
	hide:function (el) {
		el.style.display = 'none';
	},
	removeClass:function (els, className) {
		for(var i = 0; i < els.length; i++) {
			els[i].classList.remove(className)
		}
	}
}

const bookView = {
	el:{
		conform:{
			title: document.getElementById('conform-title'),
			line_1: document.getElementById('conform-line_1'),
			line_2: document.getElementById('conform-line_2'),
			cost: document.getElementById('conform-cost'),
			deposit: document.getElementById('conform-deposit'),
			startup: document.getElementById('conform-startup'),
			service: document.getElementById('conform-service'),
			allowance: document.getElementById('conform-allowance'),
			discount: document.getElementById('conform-discount'),
			startDate: document.getElementById('conform-start_date'),
			conformExtra: document.getElementById('conform-extra'),
		},
		error: {
			welcome: document.querySelector('.error-box-welcome'),
			account: document.querySelector('.error-box-account'),
			storage: document.querySelector('.error-box-storage'),
			vehicle: document.querySelector('.error-box-vehicle'),
			extra: document.querySelector('.error-box-extra'),
			conform: document.querySelector('.error-box-conform'),
		},
		img: document.querySelector('.box-info'),
		btn:{
			nextList: document.querySelectorAll('.js-btn-next'),
			mapOpen: document.getElementById('show-map'),
			mapOpenNoOption: document.getElementById('show-map-no-option'),
			mapClose: document.getElementById('map-close-btn'),
		},
		btnBar: {
			mapTap: document.getElementById('map-tab-holder'),
		},
		message:{
			rentPackage: document.getElementById('message-rent-package'),
			storageNoOptions: document.getElementById('message-storage-no-option'),
			storageStartDate: document.getElementById('message-storage-start_date'),
			workspaceNoOptions: document.getElementById('message-workspace-no-option'),
			accountMailNotValid: document.getElementById('message-account-email-no-valid'),
		},
		panel:{
			newCustomer: document.getElementById('panel-new-customer'),
			showDiscount: document.getElementById('panel-show-discount'),
			inputDiscount: document.getElementById('panel-input-discount'),
			welcomeType: document.getElementById('panel-welcome-type'),
			welcomeFull: document.getElementById('panel-welcome-full'),
			storagePackage: document.getElementById('panel-storage-package'),
			storagePlace: document.getElementById('panel-storage-place'),
			workspacePackage: document.getElementById('panel-workspace-package'),
			vehicleBoat: document.getElementById('panel-vehicle-boat'),
			vehicleSize: document.getElementById('panel-vehicle-size'),
			license: document.getElementById('panel-license_plate'),
			conformDeposit: document.getElementById('conform-deposit-panel'),
			conformStartup: document.getElementById('conform-startup-panel'),
			conformService: document.getElementById('conform-service-panel'),
			conformAllowance: document.getElementById('conform-allowance-panel'),
			conformExtra: document.getElementById('conform-extra-panel'),
			map: document.getElementById('map'),
			boxForm: document.getElementById('panel-box-form'),
			extraList: document.getElementById('panel-extra-list'),
		},
		title:{
			rent: document.getElementById('sheet-title-rent'),
			vehicle: document.getElementById('sheet-title-vehicle'),
		},
		usp: document.querySelectorAll('.box-usp'),
		resultKvk: document.getElementById('result-kvk'),
		resultKvkBg: document.getElementById('result-kvk-bg'),
		messagePrice: document.getElementById('message-price'),
		messagePlace: document.getElementById('message-place'),
	},
	field:{
		type: document.querySelector('select[name=type]'),
		location: document.querySelector('select[name=location]'),
		// Rent
		startDate: document.querySelector('input[name=start_date]'),
		package: document.querySelector('select[name=package]'),
		priceId: document.querySelector('select[name=price_id]'),
		place: document.querySelector('select[name=place]'),
		// Account
		email: document.querySelector('input[name=email]'),
		accountType: document.querySelector('select[name=account_type]'),
		companyName: document.querySelector('input[name=company_name]'),
		kvk: document.querySelector('input[name=kvk]'),
		firstName: document.querySelector('input[name=first_name]'),
		lastName: document.querySelector('input[name=last_name]'),
		mobile: document.querySelector('input[name=mobile]'),
		mobileCounty: document.querySelector('select[name=mobile_country]'),
		country: document.querySelector('select[name=country]'),
		zipcode: document.querySelector('input[name=zipcode]'),
		number: document.querySelector('input[name=number]'),
		street: document.querySelector('input[name=street]'),
		city: document.querySelector('input[name=city]'),
		// Vehicle
		vehicleTypeDisabled: document.querySelector('input[name=vehicle_type_disabled]'),
		license_plate: document.querySelector('input[name=license_plate]'),
		license_plate_country: document.querySelector('select[name=license_plate_country]'),
		length_cm: document.querySelector('input[name=length_cm]'),
		width_cm: document.querySelector('input[name=width_cm]'),
		height_cm: document.querySelector('input[name=height_cm]'),
		brand: document.querySelector('input[name=brand]'),
		model: document.querySelector('input[name=model]'),
		boot_name: document.querySelector('input[name=boot_name]'),
		registration_no: document.querySelector('input[name=registration_no]'),
		mast_length_cm: document.querySelector('input[name=mast_length_cm]'),
		draft_cm: document.querySelector('input[name=draft_cm]'),
		// Conform
		description: document.querySelector('textarea[name=description]'),
		discountCode: document.querySelector('input[name=discount_code]'),
		verificationCode: document.querySelector('input[name=verification_code]'),
	},
	col:{
		company: document.getElementById('company-col'),
	},
	sheet:{
		all: document.querySelectorAll('.sheet'),
	},
	state: {
		init: false,
		sheet: null,

		// Welcome
		location: null,
		type: null,
		// Storage
		startDate: null,
		package: null,
		priceId: null,
		placeId: null,

		// Extra
		extraLoadType: null, // Store if extra is rendered for current type
		extraLoadFrequency: null, // Store if extra is rendered for current frequency

		// Account
		email: null,
		isNewCustomer: null,
		isNotValidEmail: null,
		isPrivate: null,
		accountType: null,
		companyName: null,
		kvk: null,
		firstName: null,
		lastName: null,
		mobile: null,
		mobileCountry: null,
		zipcode: null,
		number: null,
		street: null,
		city: null,
		// Vehicle
		length_cm: null,
		width_cm: null,
		height_cm: null,
		brand: null,
		model: null,
		boot_name: null,
		registration_no: null,
		mast_length_cm: null,
		draft_cm: null,
		license_plate: null,
		license_plate_country: null,
		// Conform
		description: null,
		discountCode: null,
		discountCodeAuto: false,
		currentPrice: null,
		currentLocationOb: {id: null, for:[]},
		currentLocationTypeOb: {online:null, map:[]},

		//
		articleIdList: [],
		emailPreviousCheck: null,
		verificationCode: null,
		errors: null,
		showNextButton: true,
		mapInit: false,
		currentMapId: null,
		currentMapTypeId: null,

		rendered: {
			renderSheetRent: false,
		},
	},
	json:{
		locationTypeList: null,
	},
	request:{
		place: {url:null,data:null},
		created: {status: null, is_login:null, link:null},
		discount: {code: null, title: null},
		address: {url: null, data: {postcode: null, number: null, street: null, city: null}, timeout: null},
		company: {url: null, data: [{business_name: null, kvk: null, city:null, street:null}], timeout: null}
	},
	enum:{
		sheet: {
			welcome: 'welcome',
			rent: 'rent',
			vehicle: 'vehicle',
			account: 'account',
			extra: 'extra',
			conform: 'conform',
			send: 'send',
		},
	},
	prefer:{
		type: null, // is now typeId
		date: null,
		square: null,
		volume: null,
		locationId: null,
		priceId: null,
		packageId: null,
		email: null,
		csrf: null,
	},

	init(){
		if(this.state.init){
			return;
		}
		this.state.init = true;
		this.setDefault();
		this.setListener();
		this.updateState();
		this.render();
		this.renderUsp();
		this.mapClose();
	},

	updateState(){
		this.setState();
		this.requestData();
	},

	setDefault() {
		this.state.sheet = this.enum.sheet.welcome;

		// Jump to next screen if there is only 0 item
		if(this.json.locationTypeList && this.json.locationTypeList.length === 1 && this.json.locationTypeList[0].for.length === 1){
			let type = this.json.locationTypeList[0].for[0];
			this.prefer.type = type.type_info_id;
			this.state.sheet = enumList.typeInfo.isVehicleOrMarina(this.prefer.type)
				? this.enum.sheet.vehicle
				: this.enum.sheet.rent;
		}

		// Search params
		const urlSearchParams = new URLSearchParams(window.location.search);
		if(urlSearchParams.has('type_info_id')){
			let typeId = parseInt(urlSearchParams.get('type_info_id'));
			let locationInfo = this.json.locationTypeList.find( e  => e.id === this.prefer.locationId);
			let type = locationInfo ? locationInfo.for.find( e  => e.type_info_id === typeId) : null;
			if(type){
				this.prefer.type = typeId;
				this.state.sheet = enumList.typeInfo.isVehicleOrMarina(this.prefer.type)
					? this.enum.sheet.vehicle
					: this.enum.sheet.rent;
			} else {
				console.debug('Unknown type', locationInfo);
			}
		}
		if(urlSearchParams.has('volume')){
			this.prefer.type = enumList.typeInfo.id.storage;
			this.prefer.volume = parseFloat(urlSearchParams.get('volume'));
			this.state.sheet = this.enum.sheet.rent;
		}
		if(urlSearchParams.has('square')){
			this.prefer.type = enumList.typeInfo.id.workspace;
			this.prefer.square = parseFloat(urlSearchParams.get('square'));
		}
		if(urlSearchParams.has('date')){
			let date = inputDateForState.dateToEn(new Date(urlSearchParams.get('date')));
			this.prefer.date = date;
			this.field.startDate.value = date; // Force
		}
		if(urlSearchParams.has('typeId')){ // @deprecated, use type_id
			this.prefer.type = parseInt(urlSearchParams.get('typeId'));
		}
		if(urlSearchParams.has('type_id')){
			this.prefer.type = parseInt(urlSearchParams.get('type_id'));
		}
		if(urlSearchParams.has('package_id')){
			this.prefer.packageId = parseFloat(urlSearchParams.get('package_id'));
		}
		if(urlSearchParams.has('price_id')){
			this.prefer.priceId = parseFloat(urlSearchParams.get('price_id'));
		}

		//
		panel.hide(this.el.panel.showDiscount);
		panel.hide(this.el.resultKvk);
		panel.hide(this.el.resultKvkBg);
		this.el.resultKvkBg.onclick = this.onCompanyAutoComplete.bind(this, null);
	},

	setListener(){
		this.field.package.addEventListener('change', this.onFieldChange.bind(this));
		this.field.priceId.addEventListener('change', this.onFieldChange.bind(this));
		this.field.location.addEventListener('change', this.onFieldChange.bind(this));
		this.field.type.addEventListener('change', this.onFieldChange.bind(this));
		this.field.accountType.addEventListener('change', this.onFieldChange.bind(this));
		this.field.email.addEventListener('keyup', this.onMailChange.bind(this));
		this.field.startDate.addEventListener('change', this.onFieldChange.bind(this));
		this.field.zipcode.addEventListener('keyup', this.onFieldZipcode.bind(this));
		this.field.number.addEventListener('keyup', this.onFieldZipcode.bind(this));
		this.field.companyName.addEventListener('keyup', this.onFieldCompanyName.bind(this));
		this.el.btn.mapOpen.addEventListener('click', this.onMapOpen.bind(this));
		this.el.btn.mapOpenNoOption.addEventListener('click', this.onMapOpen.bind(this));
		this.el.btn.mapClose.addEventListener('click', this.mapClose.bind(this));

		document.addEventListener('translationsSwitchLanguage', (event) => {
			if (this.state.rendered.renderSheetRent) {
				this.renderSheetRent();
			}
		});
	},

	setState(){
		// General
		this.state.description = this.field.description.value ? this.field.description.value : null;
		this.state.discountCode = this.field.discountCode.value ? this.field.discountCode.value.toUpperCase() : null;

		// Rent
		this.state.startDate = this.field.startDate ? this.field.startDate.value : this.prefer.date;
		this.state.packageId = this.field.package.value ? parseFloat(this.field.package.value) : null;
		this.state.priceId = this.field.priceId.value ? parseInt(this.field.priceId.value) : null;
		this.state.placeId = this.field.place.value ? parseInt(this.field.place.value) : null;

		//
		this.state.location = this.field.location.value ? parseInt(this.field.location.value) : this.prefer.locationId;
		this.state.type = this.field.type && this.field.type.value ? parseInt(this.field.type.value) : this.prefer.type;
		this.state.verificationCode = this.field.verificationCode ? this.field.verificationCode.value : null;

		if(this.state.sheet === this.enum.sheet.account){
			this.state.email = this.field.email ? this.field.email.value : this.prefer.email;
			this.state.isPrivate = this.field.accountType ? ([enumList.user.accountType.private, enumList.user.accountType.receiver].includes(this.field.accountType.value)) : null;
			this.state.accountType = this.field.accountType ? this.field.accountType.value : null;
			this.state.companyName =  this.field.companyName ? this.field.companyName.value : null;
			this.state.kvk =  this.field.kvk ? this.field.kvk.value : null;
			this.state.firstName =  this.field.firstName ? this.field.firstName.value : null;
			this.state.lastName =  this.field.lastName ? this.field.lastName.value : null;
			this.state.mobile =  this.field.mobile ? this.field.mobile.value : null;
			this.state.mobileCountry =  this.field.mobileCounty ? this.field.mobileCounty.value : null;
			this.state.country =  this.field.country ? this.field.country.value : null;
			this.state.zipcode =  this.field.zipcode ? this.field.zipcode.value : null;
			this.state.number =  this.field.number ? this.field.number.value : null;
			this.state.street =  this.field.street ? this.field.street.value : null;
			this.state.city =  this.field.city ? this.field.city.value : null;
			if(this.state.isNewCustomer === null){
				this.onMailChange();
			}
		}
		if(enumList.typeInfo.isVehicleOrMarina(this.state.type)){
			this.state.length_cm = this.field.length_cm ? this.field.length_cm.value : null;
			this.state.width_cm = this.field.width_cm ? this.field.width_cm.value : null;
			this.state.height_cm = this.field.height_cm ? this.field.height_cm.value : null;
			this.state.brand = this.field.brand ? this.field.brand.value : null;
			this.state.model = this.field.model ? this.field.model.value : null;
			this.state.boot_name = this.field.boot_name ? this.field.boot_name.value : null;
			this.state.registration_no = this.field.registration_no ? this.field.registration_no.value : null;
			this.state.mast_length_cm = this.field.mast_length_cm ? this.field.mast_length_cm.value : null;
			this.state.draft_cm = this.field.draft_cm ? this.field.draft_cm.value : null;
			this.state.license_plate = this.field.license_plate ? this.field.license_plate.value : null;
			this.state.license_plate_country = this.field.license_plate_country ? this.field.license_plate_country.value : null;
		}
		else{
			this.state.length_cm = null;
			this.state.width_cm = null;
			this.state.height_cm = null;
			this.state.brand = null;
			this.state.model = null;
			this.state.boot_name = null;
			this.state.registration_no = null;
			this.state.mast_length_cm = null;
			this.state.draft_cm = null;
			this.state.license_plate = null;
			this.state.license_plate_country = null;
		}
	},
	requestData(){
		let url = '';
		if(this.state.sheet === this.enum.sheet.rent){
			if(!this.state.location){
				console.error('missing location id', this.state);
				return
			}
			let vehicleInfo = '';
			if(enumList.typeInfo.isVehicleOrMarina(this.state.type)){
				vehicleInfo = '?l=' + (this.state.length_cm ? this.state.length_cm : 402) // Can be empty, use dummie
					+ (this.state.width_cm ? '&w=' + this.state.width_cm + '' : '')
					+ (this.state.height_cm ? '&h=' + this.state.height_cm + '' : '')
			}

			url = '/api/book/place/' + this.state.location + '/' + this.state.type + '/' + this.state.startDate + vehicleInfo
			if(this.request.place.url !== url){
				this.request.place = requestHelper.getOb(url);
			}
		}
	},
	onMailChange(){
		this.state.email = this.field.email ? this.field.email.value : null;
		if(this.state.email == this.state.emailPreviousCheck){
			return;
		}
		this.state.isNewCustomer = false;
		this.state.showNextButton = false;

		// Add check
		let checkMail = this.state.email && /^.{2,}\@.{2,}\.\w{2,}$/.test(this.state.email);
		this.state.isNotValidEmail = !checkMail;
		this.render();

		if(!checkMail){
			this.state.emailPreviousCheck = null;
			return;
		}

		// Do call
		const info = requestHelper.getFetchJson('/api/book/u/' + this.state.location + '/' + this.state.email);
		info.then(r => {
			this.state.emailPreviousCheck = this.state.email;
			this.state.isNotValidEmail = false;
			this.state.showNextButton = true;
			this.state.isNewCustomer = !r.o;
			this.render();
		}).catch(e => console.error(e));
	},

	onFieldChange(e){
		// Remove warning prefer of user chooses another price
		if(this.prefer.volume && e && e.target === this.field.priceId){
			this.prefer.volume = null;
		}

		this.updateState();
		this.render();
	},
	onFieldCompanyName(){
		this.setState();
		panel.hide(this.el.resultKvk);
		panel.hide(this.el.resultKvkBg);
		if(!this.state.companyName){
			if(this.request.company.timeout){clearTimeout(this.request.company.timeout);}
			return;
		}

		// Check on url call
		let url = '/api/book/company/' + this.state.companyName;
		if(this.request.company.url === url){
			return;
		}
		this.request.company.url = url;

		// Call
		if(this.request.company.timeout){clearTimeout(this.request.company.timeout);}
		this.request.company.timeout = setTimeout(() => {
			requestHelper.getFetchJsonOb(url)
				.then(o => {
					panel.hide(this.el.resultKvk);
					panel.hide(this.el.resultKvkBg);

					if(o.response.status !== 200){
						return;
					}
					if(o.json.data){
						this.request.company.data = o.json.data;
						panel.show(this.el.resultKvk);
						panel.show(this.el.resultKvkBg);
						this.el.resultKvk.innerHTML = null;
						this.request.company.data.forEach(function (item){
							let el = document.createElement('div');
							el.innerHTML =  `${item.business_name} in ${item.city}`;
							el.onclick = this.onCompanyAutoComplete.bind(this, item.kvk);
							this.el.resultKvk.append(el);
						}.bind(this))
					}
				})
				.catch(e => console.error(e));
		}, 400);
	},

	onCompanyAutoComplete(kvk){
		let item = this.request.company.data.find(function (e){ return e.kvk === kvk})
		if(!item){
			panel.hide(this.el.resultKvk);
			panel.hide(this.el.resultKvkBg);
			return;
		}
		this.field.companyName.value = item.business_name;
		this.field.kvk.value = item.kvk;
		this.field.city.value = item.city;
		this.field.street.value = item.street;
		panel.hide(this.el.resultKvk);
		panel.hide(this.el.resultKvkBg);
	},
	onFieldZipcode(){
		this.setState();
		if(!this.state.zipcode || this.state.zipcode.length < 6 || !this.state.number){
			if(this.request.address.timeout){clearTimeout(this.request.address.timeout);}
			return;
		}

		// Check on url call
		let url = '/api/book/address/' + this.state.zipcode + '/' +this.state.number;
		if(this.request.address.url === url){
			return;
		}
		this.request.address.url = url;

		// Call to
		if(this.request.address.timeout){clearTimeout(this.request.address.timeout);}
		this.request.address.timeout = setTimeout(() => {
			requestHelper.getFetchJsonOb(url)
				.then(o => {
					if(o.response.status !== 200){
						this.field.street.value = '';
						this.field.city.value = '';
						return;
					}
					if(o.json.data){
						this.request.address.data = o.json.data;
						this.field.zipcode.value = this.request.address.data.postcode;
						this.field.number.value = this.request.address.data.number;
						this.field.street.value = this.request.address.data.street;
						this.field.city.value = this.request.address.data.city;
					}
				})
				.catch(e => console.error(e));
		}, 400);
	},
	onMapOpen(id, typeId){
		this.setSheetMapStatus(true);
		if(id && typeId){
			window.bookViewStub.que.push(() => {
				panel.show(bookView.el.panel.map)
				bookMap.init(id, typeId);
				this.state.mapInit = true;
			});
		}
		else{
			panel.show(bookView.el.panel.map);
			// Happend on mobile and use show map button
			let type = this.getTypeInfo();
			if(type.type_id !== this.state.currentMapTypeId){
				this.state.mapInit = false;
				this.state.currentMapTypeId = type.type_id;
			}
			if(!this.state.mapInit && this.state.currentMapId && this.state.currentMapTypeId){
				bookMap.init(this.state.currentMapId, this.state.currentMapTypeId);
				this.state.mapInit = true;
			}
		}

		// Rerender size
		setTimeout(() => {
			window.bookViewStub.que.push(() => {
				bookMap.resizeCanvas();
				bookMap.render();
			});
		}, 220)
	},
	mapClose(){
		this.setSheetMapStatus(false);
		panel.hide(this.el.panel.map);
	},
	setSheetMapStatus(state){
		let sh = document.querySelector('.box-form');
		if(sh){
			if(state) {
				sh.classList.add('map-open');
			}
			else{
				sh.classList.remove('map-open');
			}
		}
	},
	onUsePlace(place_id, fromDate){
		let currentPackageId = this.state.packageId;
		let packageId = null;
		let priceId = null;

		// Set date | Needed first for select place
		if(fromDate){
			this.state.startDate = new Date(fromDate);
			this.field.startDate.value = inputDateForState.dateToEn(this.state.startDate);
			this.onFieldChange();
		}
		// Search for fist package
		let findCurrent = false;
		for(let i = 0; i < this.request.place.data.list.length; i++){
			let packList = this.request.place.data.list[i];
			for(let ii = 0; ii < packList.prices.length; ii++){
				let priceList = packList.prices[ii];
				for(let iii = 0; iii < priceList.places.length; iii++){
					let place = priceList.places[iii];
					if(place.place_id === place_id){
						if(!packageId){
							packageId = packList.package_id;
							priceId = priceList.price_id;
						}
						if(currentPackageId === packList.package_id){
							packageId = packList.package_id;
							priceId = priceList.price_id;
							findCurrent = true;
							break
						}
					}
					if(findCurrent){
						break
					}
				}
				if(findCurrent){
					break
				}
			}
			if(findCurrent){
				break
			}
		}

		this.state.packageId = packageId;
		this.state.priceId = priceId;
		this.state.placeId = place_id;
		this.renderSheetRent();
		this.state.showNextButton = true;
		this.renderNextButton();
		if(this.isMobielWith()){
			this.mapClose();
		}
	},
	actionResendVerification(){
		requestHelper.postFetch(this.prefer.csrf, '/api/book/code-resend', {
			mail: this.state.email,
			location_id: this.state.location,
		})
			.then(r => {
				alert(__('booking.sent'));
			})
			.catch(e => console.error(e));
	},
	actionCheckVerification(){
		requestHelper.postFetch(this.prefer.csrf, '/api/book/code-check', {
			mail: this.state.email,
			code: this.field.verificationCode.value,
			location_id: this.state.location,
		})
			.then(r => {
				if(r.status === 200){
					this.openLink(this.request.created.link);
				}
				else{
					alert(__('booking.invalid_code'))
				}
			})
			.catch(e => console.error(e));
	},

	// Actions
	send(){
		this.updateState();
		let jsonOb = {
			// Welcome
			location_id: this.state.location,
			type_info_id: this.state.type,

			// General type
			start_date: this.state.startDate,
			price_id: this.state.priceId,
			place_id: this.state.placeId,

			// Account
			email: this.state.email,
			account_type: this.state.accountType,
			business_name: this.state.companyName,
			business_kvk: this.state.kvk,
			first_name: this.state.firstName,
			last_name: this.state.lastName,
			mobile: this.state.mobile,
			mobile_country: this.state.mobileCountry,
			country: this.state.country,
			zipcode: this.state.zipcode,
			house_number: this.state.number,
			street: this.state.street,
			city: this.state.city,
			// Vehicle
			length_cm: this.state.length_cm,
			width_cm: this.state.width_cm,
			height_cm: this.state.height_cm,
			brand: this.state.brand,
			model: this.state.model,
			boot_name: this.state.boot_name,
			registration_no: this.state.registration_no,
			mast_length_cm: this.state.mast_length_cm,
			draft_cm: this.state.draft_cm,
			license_plate: this.state.license_plate,
			license_plate_country: this.state.license_plate_country,
			article_list: this.getArticleIdList(),
			// Conform
			description: this.state.description,
			discount_code: this.state.discountCode,
		};


		let json = JSON.stringify(jsonOb);
		let handle = function (e){
			let xhr = e.currentTarget;
			if(xhr.readyState !== 4){
				return;
			}
			this.state.errors = null;
			if(xhr.status === 200){
				this.request.created = JSON.parse(xhr.response);
				// If already login, open user
				if(this.request.created.is_login){
					this.openLink(this.request.created.link);
				}
				else{
					// Open OneTime code screen
					this.setSheet(this.enum.sheet.send);
				}
				return;
			}

			// Errors
			let errors = JSON.parse(xhr.response);
			this.state.errors = errors && errors.screen ? errors.screen : null;
			let errorList = this.state.errors;
			if(!errorList){
				console.error(errors);
				return;
			}

			if(errorList.account){
				this.setSheet(this.enum.sheet.account);
				return;
			}
			else if(errorList.storage){
				this.setSheet(this.enum.sheet.rent);
				return;
			}
			else if(errorList.vehicle){
				this.setSheet(this.enum.sheet.vehicle);
				return;
			}
			else if(errorList.extra){
				this.setSheet(this.enum.sheet.extra);
				return;
			}
			else if(errorList.conform){
				this.setSheet(this.enum.sheet.conform);
				return;
			}
			else{
				console.error('unknown error action', errorList);
				this.setSheet(this.enum.sheet.account);
				return;
			}

		}
		requestHelper.post('/api/book/store', json, handle.bind(this), true, this.prefer.csrf);
	},
	setSheet(name){
		this.setState(); // Update state

		let to = '';
		this.mapClose();

		let type = this.getTypeInfo();
		let hasExtra = type.article && type.article.length > 0;
		if(name === 'next'){
			if(this.state.sheet === this.enum.sheet.welcome){
				if(!this.state.type){
					panel.show(this.el.error.welcome);
					tEl(this.el.error.welcome, 'booking.choose_a_type')
					return;
				}
				to = enumList.typeInfo.isVehicleOrMarina(this.state.type)
					? this.enum.sheet.vehicle
					: this.enum.sheet.rent;
				this.state.currentMapId = null; // Reset
			}
			else if(this.state.sheet === this.enum.sheet.vehicle){
				let validate = this.validateVehicle();
				if(validate && (!type || !type.book_skip_size)){
					panel.show(this.el.error.vehicle);
					tEl(this.el.error.vehicle, 'booking.fill_in_all_fields[error:' + validate + ']')
					return
				}
				else{
					to = this.enum.sheet.rent;
				}
			}
			else if(this.state.sheet === this.enum.sheet.rent){
				let diffInDay = inputDateForState.diffInDay(new Date(), new Date(this.state.startDate));
				if(diffInDay < 0){
					panel.show(this.el.error.storage);
					tEl(this.el.error.storage, 'booking.incorrect_start_date')
					return;
				}
				to = hasExtra ? this.enum.sheet.extra : this.enum.sheet.account;
			}
			else if(this.state.sheet === this.enum.sheet.extra){to = this.enum.sheet.account;}
			else if(this.state.sheet === this.enum.sheet.account){to = this.enum.sheet.conform;}
			else{
				return console.error('unknown sheet', this.state.sheet);
			}
		}
		else if(name === 'back'){
			this.state.showNextButton = true;
			if(this.state.sheet === this.enum.sheet.vehicle){to = this.enum.sheet.welcome;}
			else if(this.state.sheet === this.enum.sheet.rent){
				to = enumList.typeInfo.isVehicleOrMarina(this.state.type)
					? this.enum.sheet.vehicle
					: this.enum.sheet.welcome;
			}
			else if(this.state.sheet === this.enum.sheet.account){to = hasExtra ? this.enum.sheet.extra : this.enum.sheet.welcome;}
			else if(this.state.sheet === this.enum.sheet.extra){to = this.enum.sheet.rent;}
			else if(this.state.sheet === this.enum.sheet.conform){to= this.enum.sheet.account}
			else{
				return console.error('unknown action');
			}
		}
		else{
			to = name;
		}
		this.state.sheet = to;
		this.updateState();
		this.render();
	},

	openLink(link){
		// Fix issue then book module is in iframe!
		top.window.location.href = link;
	},
	checkDiscountCode(){
		this.setState(); // Update state

		panel.hide(this.el.panel.showDiscount);

		let jsonOb = {
			code: this.state.discountCode,
			price_id: this.state.priceId,
		}
		jsonOb.price_id = this.state.priceId;
		requestHelper.postFetch(this.prefer.csrf, '/api/book/discount-check', jsonOb).then(r => {
			if(r.status !== 200){
				alert(__('booking.invalid_code'))
				return null;
			}
			return r.json();
		})
			.then(r => {
				this.request.discount = r;
				if(r){
					this.setDiscount(this.request.discount.code, this.request.discount.title);
				}
			})
			.catch(e => console.error(e));
	},
	setDiscount(code, text){
		this.state.discountCode = code;
		this.field.discountCode.value = code;
		panel.set(this.el.panel.showDiscount, code);
		if(code){
			this.el.conform.discount.innerHTML = "<span class='flag success'>" + text + "</span>";
		} else {
			this.el.conform.discount.innerHTML = '';
		}
	},

	// Validate
	validateVehicle(){
		if(this.state.length_cm < 10){
			return __('booking.lacks_length');
		}
		if(this.state.width_cm < 10){
			return __('booking.lacks_width');
		}
		if(!this.state.brand){
			return __('booking.lacks_brand');
		}
		if(!this.state.model){
			return __('booking.lacks_model');
		}
		return null;
	},

	// Render
	render(){
		this.renderSheet();
	},
	renderSheet(){
		// Width instellen
		this.el.panel.boxForm.classList.remove('box-wide-60');
		if([this.enum.sheet.extra].includes(this.state.sheet)){
			this.el.panel.boxForm.classList.add('box-wide-60');
		}

		this.sheet.all.forEach(e => {
			panel.set(e, this.state.sheet === e.getAttribute('data-sheet'));
		});

		// Render sheet elements
		if(this.state.sheet === this.enum.sheet.welcome){this.renderSheetWelcome();}
		if(this.state.sheet === this.enum.sheet.vehicle){this.renderSheetVehicle();}
		if(this.state.sheet === this.enum.sheet.rent){this.renderSheetRent();}
		if(this.state.sheet === this.enum.sheet.extra){this.renderSheetExtra();}
		if(this.state.sheet === this.enum.sheet.account){this.renderSheetAccount();}
		if(this.state.sheet === this.enum.sheet.conform){this.renderSheetConform();}

		//
		this.renderNextButton();

		// Set background image
		let typeImg = (this.state.type ? this.state.type : 0);
		this.el.img.style.backgroundImage =
			'url("/image/location/' + this.state.location +'/book/' + typeImg + '.jpg"),'
			+ 'url("/image/book/backup/' + typeImg + '.jpg")' // Backup image
	},

	renderNextButton(){
		this.el.btn.nextList.forEach(e => { panel.set(e, this.state.showNextButton);});
	},

	renderSheetWelcome(){
		// Reset selects
		panel.hide(this.el.error.welcome);
		selectHelper.removeAll(this.field.type);
		selectHelper.removeAll(this.field.location);

		if(!this.json.locationTypeList){
			return;
		}
		let hasMoreItems = false;
		let isFull = true;
		for(let i = 0; i < this.json.locationTypeList.length; i++){
			let location = this.json.locationTypeList[i];
			let current = this.state.location ? this.state.location === location.id : (i === 0);
			selectHelper.add(this.field.location, location.id, location.name, current);
			let hasCurrentType = false;
			if(current && location.for.length){
				hasMoreItems = location.for.length > 1;
				selectHelper.add(this.field.type, '', 'booking.choose_a_type', false, false, true);
				for(let ii = 0; ii < location.for.length; ii++) {
					let type = location.for[ii];
					if(type.is_full === false){
						isFull = false;
					}
					let currentType = type.disable ? null : ( this.state.type
						? (this.state.type === type.type_info_id)
						: (this.prefer.type === type.type_info_id));
					if(currentType){
						hasCurrentType = currentType;
					}
					selectHelper.add(this.field.type, type.type_info_id, type.title, currentType, type.disable, true);
				}
				// No current?
				if(!hasCurrentType){
					for(let ii = 0; ii < location.for.length; ii++) {
						let type = location.for[ii];
						if(!type.disable){
							this.state.type = type.type_info_id;
							this.field.type.value = type.type_info_id;
							break;
						}
					}
				}
			}
		}

		// Set full message
		tEl(this.el.panel.welcomeFull, 'booking.location_is_full');
		panel.set(this.el.panel.welcomeFull, isFull);
		if(isFull){
			this.state.showNextButton = false;
		}

		//
		this.state.type = this.field.type.value; // Set state for background image
		panel.set(this.el.panel.welcomeType, hasMoreItems && !isFull);
	},
	renderSheetVehicle(){
		panel.hide(this.el.error.vehicle);
		panel.hide(this.el.panel.license);
		panel.hide(this.el.panel.vehicleBoat);
		this.state.showNextButton = true;

		//
		let type = this.getTypeInfo();

		// Error
		if(this.state.errors && this.state.errors.vehicle){
			panel.show(this.el.error.vehicle);
			this.el.error.vehicle.innerHTML = '';
			for (const [field, notes] of Object.entries(this.state.errors.vehicle)) {
				this.el.error.vehicle.innerHTML += notes.join(', ') + '<br>';
			}
		}

		// Title
		let objectType = (this.state.type === enumList.typeInfo.id.marina  || this.state.type === enumList.typeInfo.id.boats ? __('booking.vessel').toLowerCase() : __('booking.vehicle').toLowerCase())
		tEl(this.el.title.vehicle, 'booking.information_about_object[object:' + objectType + ']')

		// License plate

		// Type field
		this.field.vehicleTypeDisabled.value = enumList.typeInfo.idToName(this.state.type);

		// Boat field
		if(this.state.type === enumList.typeInfo.id.boats || this.state.type === enumList.typeInfo.id.marina ){
			panel.show(this.el.panel.vehicleBoat);
		}
		else{
			panel.show(this.el.panel.license);
		}

		// Size
		panel.set(this.el.panel.vehicleSize, type && !type.book_skip_size);
	},
	renderSheetRent(){
		// Errors
		panel.hide(this.el.error.storage);

		if(this.state.errors && this.state.errors.storage){
			panel.show(this.el.error.storage);
			this.el.error.storage.innerHTML = '';
			for (const [field, notes] of Object.entries(this.state.errors.storage)) {
				this.el.error.storage.innerHTML += notes.join(', ') + '<br>';
			}
		}

		// Set title
		let tKey = 'booking.package_and_moment';
		if(this.state.type === enumList.typeInfo.id.storage){
			tKey = 'booking.the_storage_box';
		}
		else if(this.state.type === enumList.typeInfo.id.workspaces){
			tKey = 'booking.the_business_premises';
		}
		else if(this.state.type === enumList.typeInfo.id.office){
			tKey = 'booking.the_office_space';
		}
		else if(this.state.type === enumList.typeInfo.id.garagebox){
			tKey = 'booking.the_garage_box';
		}
		else if(enumList.typeInfo.isVehicleOrMarina(this.state.type)){
			tKey = 'booking.package_and_moment';
		}
		tEl(this.el.title.rent, tKey)

		// Set message date
		let text = '';
		let type = this.getTypeInfo();

		let hasBookMinNotToday = type.book_min && new Date(type.book_min).setHours(0,0,0,0) !== new Date().setHours(0,0,0,0);
		if(type.book_min && hasBookMinNotToday){
			let min = new Date(type.book_min);
			let todayDate = new Date();
			todayDate.setHours(0,0,0,0);
			let minIsToday = min.getTime() === todayDate.getTime();

			text = (type.book_max
				? language().span('booking.choose_date_between') + ' ' + inputDateForState.dateToNl(min)
				: (minIsToday ? '' : language().span('booking.can_be_reserved_from') + ' ' + inputDateForState.dateToNl(min)));
			this.field.startDate.min = inputDateForState.dateToEn(min);
			if(new Date(this.field.startDate.value) < min){
				this.field.startDate.value = inputDateForState.dateToEn(min);
			}
		}
		if(type.book_max){
			let max = new Date(type.book_max);
			text += (hasBookMinNotToday ? ' ' + language().span('booking.and') + ' ' : language().span('booking.choose_date_earlier_than') + ' ') + inputDateForState.dateToNl(max);
			this.field.startDate.max = inputDateForState.dateToEn(max);
		}

		panel.set(this.el.message.storageStartDate, text);
		if(text){
			this.el.message.storageStartDate.innerHTML = text;
		}

		// Set package and format
		selectHelper.removeAll(this.field.package);
		selectHelper.removeAll(this.field.priceId);
		if(!this.request.place.data){
			return;
		}

		// Find current, this is needed to load the format loop
		// Check of state.packageId || prefer.packageId exists
		let hasCurrent = false;
		let hasOption = false;
		if(this.state.packageId || this.prefer.packageId){
			for(let i = 0; i < this.request.place.data.list.length; i++){
				let p = this.request.place.data.list[i];
				if (this.state.packageId === p.package_id || this.prefer.packageId === p.package_id){
					hasCurrent = true;
					break;
				}
			}
		}
		panel.set(this.el.panel.storagePackage, this.request.place.data.list.length > 1);
		panel.hide(this.el.message.rentPackage);
		for(let i = 0; i < this.request.place.data.list.length; i++){
			let p = this.request.place.data.list[i];
			let pAva = (p.prices.length);
			let current = this.state.packageId
				? this.state.packageId === p.package_id
				: this.prefer.packageId === p.package_id;
			if(!hasCurrent && i === 0) {
				current = true;
			}
			selectHelper.add(this.field.package, p.package_id, p.name + (pAva ? '' : ' vol'), current, !pAva);
			if(current) {
				this.state.currentPrice = null;
				let firstVolumeCurrent = null;
				for (let ii = 0; ii < p.prices.length; ii++) {
					let vsi = p.prices[ii];
					let vAva = vsi.places && vsi.places.length > 0;
					let priceCurrent = vAva && (this.state.priceId
						? this.state.priceId === vsi.price_id
						: (this.prefer.volume === vsi.volume || this.prefer.priceId === vsi.price_id));
					if(vAva){
						if (!firstVolumeCurrent) {
							firstVolumeCurrent = vsi;
						}
						if (priceCurrent) {
							this.state.currentPrice = vsi;
						}
						hasOption = true
					}
					selectHelper.add(
						this.field.priceId,
						vsi.price_id,
						vsi.name,
						priceCurrent,
						!vAva
					);
				}
				this.state.currentPrice = this.state.currentPrice ? this.state.currentPrice : firstVolumeCurrent;
				panel.hide(this.el.messagePrice);
				this.el.messagePrice.innerHTML = '';
				if(this.prefer.volume && this.state.currentPrice && this.prefer.volume != this.state.currentPrice.volume){
					panel.show(this.el.messagePrice);
					this.el.messagePrice.innerHTML = '<span class="fa fa-warning"></span>' + language().span('booking.alternative_format_chosen') + ' ' + this.prefer.volume + ' ' + language().span('booking.space_not_available');
				}
				if(this.prefer.priceId && this.state.currentPrice && this.prefer.priceId != this.state.currentPrice.price_id){
					panel.show(this.el.messagePrice);
					this.el.messagePrice.innerHTML = '<span class="fa fa-warning"></span>' + language().span('booking.alternative_price_selected');
				}
				if(p.info){
					panel.set(this.el.message.rentPackage, true);
					this.el.message.rentPackage.innerHTML = p.info;
				}
			}
		}

		panel.hide(this.el.panel.storagePlace);
		panel.hide(this.el.messagePlace);
		panel.hide(this.el.btn.mapOpen)
		panel.hide(this.el.btn.mapOpenNoOption)
		selectHelper.removeAll(this.field.place);
		if((type.book_place_prefer === enumList.type.book_place_prefer.yes && this.state.currentPrice && this.state.currentPrice.places.length > 1)
			|| (type.book_place_prefer === enumList.type.book_place_prefer.yes_map && this.state.currentPrice && this.state.currentPrice.places.length > 0)
		){
			panel.show(this.el.panel.storagePlace);
			if(type.book_place_prefer === enumList.type.book_place_prefer.yes_map){
				panel.show(this.el.btn.mapOpen)
			}
			if(type.book_place_url){
				panel.show(this.el.messagePlace);
				this.el.messagePlace.innerHTML = '<a href="' + type.book_place_url + '" target="_blank" data-trans="booking.view"></a> <span data-trans="booking.the_floor_plan"></span>.';
			}
			selectHelper.add(this.field.place, null, __('booking.no_preference_best_spot'), true, false);
			this.state.currentPrice.places.forEach( e => {
				selectHelper.add(this.field.place, e.place_id, e.name, this.state.placeId === e.place_id, false);
			})
		} else {
			if(type.map.length > 0){
				panel.show(this.el.btn.mapOpenNoOption);
			}
		}

		// Note
		panel.hide(this.el.messagePrice);
		if(hasOption && type.book_note){
			panel.show(this.el.messagePrice);
			this.el.messagePrice.innerHTML += (this.el.messagePrice.innerHTML ? '<br>' : '') + type.book_note;
		}

		// Set map items
		if(type.map.length > 0){
			if(!this.state.currentMapId){
				this.el.btnBar.mapTap.innerHTML = '';
				this.state.currentMapId = type.map[0].id;
				this.state.currentMapTypeId = type.type_id;
				for(let i = 0; i < type.map.length; i++){
					let btnMap = document.createElement('button');
					btnMap.addEventListener('click', function (){
						bookView.el.btnBar.mapTap.querySelectorAll('button').forEach(
							a => a.classList.remove('active')
						);
						bookMap.openMap(type.map[i].id, type.type_id)
						this.classList.add('active');
					});
					btnMap.innerHTML = type.map[i].name;
					if(i === 0){
						btnMap.classList.add('active')
					}
					this.el.btnBar.mapTap.append(btnMap);
				}

				// Don't open directly for mobiel
				if(!this.isMobielWith()){
					this.onMapOpen(type.map[0].id, type.type_id);
				}
			}
			else{
				if(!this.isMobielWith()) {
					this.onMapOpen(type.map[0].id, type.type_id);
				}
			}
		}
		else{
			this.el.btnBar.mapTap.innerHTML = '';
			this.state.currentMapId = null;
		}

		this.state.showNextButton = hasOption;
		panel.set(this.field.priceId, hasOption);
		panel.set(this.el.message.storageNoOptions, !hasOption);

		// Set discount
		if(this.state.discountCodeAuto){
			this.state.discountCodeAuto = false;
			this.setDiscount(null, null);
		}
		if(this.state.currentPrice && this.state.currentPrice.package_id && !this.state.discountCode){
			if(this.request.place.data.discount_fill.length > 0){
				for (let i = 0; i < this.request.place.data.discount_fill.length; i++) {
					let it = this.request.place.data.discount_fill[i];
					if(it.type_id === type.type_id && (it.package_id === this.state.currentPrice.package_id || it.package_id === null)){
						this.state.discountCodeAuto = true;
						this.setDiscount(it.code, it.title);
						break;
					}
				}
			}
		}

		this.state.rendered.renderSheetRent = true;
	},
	renderSheetExtra(){
		// Errors
		panel.hide(this.el.error.extra);
		if(this.state.errors && this.state.errors.extra){
			panel.show(this.el.error.extra);
			this.el.error.extra.innerHTML = '';
			for (const [field, notes] of Object.entries(this.state.errors.extra)) {
				this.el.error.extra.innerHTML += notes.join(', ') + '<br>';
			}
		}

		let currentFrequency = this.state.currentPrice.frequency;
		if(!this.state.currentPrice){
			console.warn('missing price');
			return;
		}

		// Check is already loaded to keep choose
		if(this.state.extraLoadType === this.state.type && this.state.extraLoadFrequency === currentFrequency){ // Skip on no change to keep current choose
			return;
		}

		this.state.extraLoadType = this.state.type;
		this.state.extraLoadFrequency = currentFrequency;
		let type = this.getTypeInfo();
		this.el.panel.extraList.innerHTML = '';

		// Build up
		let select = document.createElement('select');
		select.classList.add('form');
		select.name = 'insure-option';
		let option0 = document.createElement('option');
		tEl(option0, 'booking.no_insurance');
		select.appendChild(option0);
		let hasInsured = false;
		let hasInsuredRequired = false;
		let hasItem = false;
		for(let i = 0; i < type.article.length; i++){
			let it = type.article[i];
			// ONLY with the same frequency
			if(it.frequency !== enumList.product.frequency.one_time && it.frequency !== currentFrequency){
				continue;
			}
			hasItem = true;
			if(it.insured){
				if(it.box_state === enumList.article.boxState.yes_required){
					hasInsuredRequired = true;
				}
				let option0 = document.createElement('option');
				option0.value = it.id;
				option0.innerHTML = it.name + ' ' + __('booking.until').toLowerCase() + ' ' + priceHelper.centToEuroLongNl(it.insured_value) + ' · ' + it.price_info;
				if(it.box_state === enumList.article.boxState.yes){
					option0.selected = true;
				}
				if(it.info){
					option0.setAttribute('info', it.info);
				}
				if(it.insured_link){
					option0.setAttribute('insured_link', it.insured_link);
				}
				select.appendChild(option0);
				hasInsured = true;
			} else {
				let neIt = this.newEl.extraArticle(it.name, it.info, it.price, it.id, false, it.box_state, it.frequency);
				this.el.panel.extraList.appendChild(neIt);
			}
		}
		if(hasInsured){
			// Remove no option
			if(hasInsuredRequired){
				select.options[0].remove();
			}

			let insuredHolde = this.newEl.extraInsure(__('booking.insurance') + ' ' + (hasInsuredRequired ? ' (' + __('booking.required').toLowerCase() + ')':''), '', select);
			this.el.panel.extraList.appendChild(insuredHolde);
		}
		if(!hasItem){
			this.el.panel.extraList.innerHTML = __('booking.no_extras_available') + '.';
		}
	},
	renderSheetAccount(){
		panel.set(this.col.company, !this.state.isPrivate);
		panel.hide(this.el.error.account);
		panel.set(this.el.panel.newCustomer, this.state.isNewCustomer);
		panel.set(this.el.message.accountMailNotValid, this.state.isNotValidEmail);

		if(this.state.errors && this.state.errors.account){
			panel.show(this.el.error.account);
			this.el.error.account.innerHTML = '';
			for (const [field, notes] of Object.entries(this.state.errors.account)) {
				this.el.error.account.innerHTML += notes.join(', ') + '<br>';
			}
		}
	},
	renderSheetConform(){
		panel.hide(this.el.error.conform);
		panel.hide(this.el.panel.inputDiscount);

		panel.set(this.el.panel.conformDeposit, this.state.currentPrice.deposit);
		panel.set(this.el.panel.conformStartup, this.state.currentPrice.startup);
		panel.set(this.el.panel.conformService, this.state.currentPrice.service);
		panel.set(this.el.panel.conformAllowance, this.state.currentPrice.allowance);

		if(this.state.errors && this.state.errors.conform){
			panel.show(this.el.error.conform);
			this.el.error.conform.innerHTML = '';
			for (const [field, notes] of Object.entries(this.state.errors.conform)) {
				this.el.error.conform.innerHTML += notes.join(', ') + '<br>';
			}
		}
		if(this.state.currentPrice.dis){
			panel.show(this.el.panel.inputDiscount);
		}

		if(!this.state.currentPrice){
			return;
		}

		let locationEl = null;
		for(let i = 0; i < this.json.locationTypeList.length; i++){
			let forEl = this.json.locationTypeList[i];
			if(forEl.id === this.state.location){
				locationEl = forEl;
				break;
			}
		}
		if(locationEl){
			this.el.conform.line_1.innerHTML = locationEl.line_1;
			this.el.conform.line_2.innerHTML = locationEl.line_2;
		}
		this.el.conform.cost.innerHTML = this.state.currentPrice.name;
		this.el.conform.deposit.innerHTML = this.state.currentPrice.deposit;
		this.el.conform.startup.innerHTML = this.state.currentPrice.startup
			+ (this.state.currentPrice.startup_reason ? ' ' + this.state.currentPrice.startup_reason:'');
		this.el.conform.service.innerHTML = this.state.currentPrice.service;
		this.el.conform.allowance.innerHTML = this.state.currentPrice.allowance
			+ (this.state.currentPrice.allowance_reason ? ' ' + this.state.currentPrice.allowance_reason : '');
		this.el.conform.startDate.innerHTML = this.state.startDate ? (new Date(this.state.startDate)).toLocaleDateString() : '';

		this.state.currentLocationOb = this.json.locationTypeList.find(e => e.id === this.state.location);
		if(this.state.currentLocationOb && this.state.type){
			this.state.currentLocationTypeOb = this.state.currentLocationOb.for.find(e => e.type_info_id === this.state.type);
		}
		if(this.state.currentLocationTypeOb && this.state.currentLocationTypeOb.online){
			this.el.conform.title.innerHTML = '<h4 data-trans="booking.finalize_your_reservation"></h4><p data-trans="booking.finalize_your_reservation_info"></p>';
		}
		else{
			this.el.conform.title.innerHTML = '<h4 data-trans="booking.finalize_your_application"></h4><p data-trans="booking.finalize_your_application_info"></p>';
		}

		// Render extra
		let extraText = [];
		let extraIdList = this.getArticleIdList();
		if(extraIdList.length > 0){
			let type = this.getTypeInfo();
			for(let i = 0; i < extraIdList.length; i++){
				let it = extraIdList[i];
				let findArticle = type.article.find(i => i.id === it);
				if(findArticle){
					extraText.push(findArticle.name);
				} else {
					console.warn('missing article:' , it);
				}
			}
		}
		panel.set(this.el.panel.conformExtra, extraText.length > 0);
		if(extraText.length > 0){
			this.el.conform.conformExtra.innerHTML = extraText.join(', ');
		}

	},
	renderUsp(){
		// Init
		this.el.usp.forEach(e => {
			let li = e.querySelectorAll('li');
			li[0].classList.add('active');
			if(li.length < 2){
				return;
			}
			let loopItem = function (liList){
				let l = liList.length;
				let n = 0;
				liList.forEach((e, i)=>{
					if(e.classList.contains('active')){n = i + 1;}
				});
				if(n >= l){n = 0;}
				liList.forEach((li, i) => {
					if(i === n){
						li.classList.add('active');
					}
					else{
						li.classList.remove('active');
					}
				})
			}

			// Loop
			setInterval(loopItem.bind(this, li), 7000);
		})

		this.el.usp.onclick = function () {slideSource.classList.toggle('fade');}
	},
	isMobielWith(){
		return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 700;
	},
	getLocationInfo(){
		if(!this.state.location){
			return null;
		}
		return  this.json.locationTypeList.find(e => e.id === this.state.location);
	},
	getTypeInfo(){
		let cLocationOb = this.getLocationInfo();
		let type = null;
		if(cLocationOb && this.state.type){
			type = cLocationOb.for.find(e => e.type_info_id === this.state.type);
		}
		return type;
	},
	getArticleIdList(){
		let idList = [];
		// Article
		let articleList = document.querySelectorAll('input[name=extra-id]');
		if(articleList && articleList.length > 0){
			articleList.forEach(e => {
				if(e.checked){
					idList.push(parseInt(e.value));
				}
			})
		}

		// Insure
		let insureEl = document.querySelector('select[name=insure-option]');
		if(insureEl && insureEl.value > 1){
			idList.push(parseInt(insureEl.value));
		}
		return idList;
	},

	// Elements
	newEl:{
		extraArticle(title, info, price, checkboxValue, active, boxState, frequency) {
			let h = document.createElement('div');
			h.classList.add('order-article');
			let h4 = document.createElement('h4');
			h4.innerHTML = title;
			let p = document.createElement('p');
			p.innerHTML = info;
			if(price){
				p.innerHTML += '<br>' + price + ' ' + language().span('booking.price_frequency.' + frequency.toLowerCase(), true);
			}
			let label = document.createElement('label');
			label.classList.add('checkbox-switch');

			let checkbox = document.createElement('input');
			checkbox.type = 'checkbox';
			checkbox.name = 'extra-id';
			checkbox.value = checkboxValue;
			if(boxState === enumList.article.boxState.yes || boxState === enumList.article.boxState.yes_required){
				// checkbox.checked = true; // Not working
				checkbox.setAttribute('checked', 'checked');
			}
			if(boxState === enumList.article.boxState.yes_required){
				checkbox.disabled = true;
				h4.innerHTML += ' (verplicht)';
			}
			label.appendChild(checkbox);
			label.innerHTML += '<span class="tgl-btn"></span><span class="label"></span>';
			h.appendChild(h4);
			h.appendChild(p);
			h.appendChild(label);
			return h;
		},
		extraInsure(title, info, select) {
			let h = document.createElement('div');
			h.id = 'order-insure';
			h.classList.add('order-article');

			let h4 = document.createElement('h4');
			h4.innerHTML = title;
			let p = document.createElement('p');
			p.innerHTML = info;
			this._setInsureText(select, p);
			select.addEventListener('change', this._setInsureText.bind(this, select, p));

			h.appendChild(h4);
			h.appendChild(p);
			h.appendChild(select);
			return h;
		},
		_setInsureText(t, p){
			let option = t.options[t.selectedIndex];
			p.innerHTML = '';
			if(option && option.getAttribute('info')){
				p.innerHTML = option.getAttribute('info');
			}

			if(option && option.getAttribute('insured_link')){
				let a = document.createElement('a');
				a.href = option.getAttribute('insured_link');
				a.target = '_blank';
				a.innerHTML = 'Bekijk voorwaarden';
				a.classList.add('insured_link');
				p.appendChild(a);
			}
		},
	},
};
var customerWizard = {
	// Item
	field: {
		email: document.getElementById('email-field'),
	},
	tr:{
		password: document.getElementById('password-tr'),
	},
	panel:{
		message: document.getElementById('message-panel'),
	},
	button:{
		go: document.getElementById('go-button'),
	},

	oldState: {},
	state:{
		email: null,
	},
	json: {
		accountCheck: null
	},

	config: {
		locationId: null,
	},

	init: function () {
		this.setState();
		this.checkAccount();
		this.render();
	},

	setState: function(){
		this.oldState = JSON.parse(JSON.stringify(this.state));
		this.state.email = this.field.email.value ? this.field.email.value : null;
	},

	// Get
	requestEmailAccount: function(locationId, email){
		this.json.accountCheck = requestHelper.getJson('/visitor/api/customer-wizard/form/email/' + locationId + '/' + email);
	},

	checkAccount: function(){
		if(!this.state.email){
			return;
		}

		if(!this.validateEmail(this.state.email)){
			return;
		}

		if(this.oldState.email != this.state.email){
			// Check if email account exists
			this.requestEmailAccount(this.config.locationId, this.state.email)
		}
	},

	validateEmail: function(email){
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	},

	change: function(){
		this.setState();
		this.checkAccount();
		this.render();
	},

	render: function(){
		this.renderEmailFeedback();
	},

	renderEmailFeedback: function(){
		view.hide(this.tr.password);
		view.hide(this.panel.message);
		if(this.json.accountCheck){
			if(this.json.accountCheck.exists){
				view.show(this.tr.password)
				view.show(this.button.go);
			}
			else{
				view.show(this.panel.message)
				view.hide(this.button.go);
			}
		}
	},
}

let homeView = {
	el:{
		img: document.getElementById('search-action-img'),
		btnListType: document.getElementById('btn-list-type'),
		btnListTypes: document.querySelectorAll('#btn-list-type button'),
		btnListFor: document.getElementById('btn-list-for'),
		btnListForBtn: document.querySelectorAll('#btn-list-for button'),

		btnListMarine: document.getElementById('btn-list-marine'),
		btnListStorage: document.getElementById('btn-list-storage'),
		btnListObject: document.getElementById('btn-list-object'),
		btnListWorkspace: document.getElementById('btn-list-workspace'),
		btnListGaragebox: document.getElementById('btn-list-garagebox'),

		btnListLocation: document.getElementById('btn-list-location'),
		btnListLocationBtn: document.querySelectorAll('#btn-list-location button'),
	},
	btn: {
		search: document.getElementById('search-go-btn')
	},
	field: {
		search: document.getElementById('place-search-field'),
	},
	state:{
		firstRender: true,
		typeVal: null,
		marineVal: null,
		storageVal: null,
		objectVal: null,
		locationVal: null,
		workspaceVal: null,
		garageboxVal: null,
	},
	enum:{
		typeMarine: 'marine',
		typeStalling: 'stalling',
		typeStorage: 'storage',
		typeWorkspace: 'workspace',
		typeGaragebox: 'garagebox',
		storageSelfStorage: 'self-storage',
		storageContainer: 'container',
		storageHomeService: 'home-service',
		marinaPasserby: 'passerby',
		marineDry: 'dry',
		marineHarbor: 'harbor',
		objectCar: 'car',
		objectOldtimer: 'oldtimer',
		objectCaravan: 'caravan',
		objectMotorHome: 'motorhome',
		objectBoat: 'boat',
		objectMotorbike: 'motorbike',
		objectFoldingTrailer: 'folding-trailer',
		objectTrailer: 'trailer',
		workspaceSpace: 'workspace-space',
		garageboxSpace: 'garagebox-space',
		locationAll: 'all',
	},

	// Func
	init() {
		this.setListener();
		this.setDefault();
		this.setState();
		this.render();
	},

	// Set
	setDefault(){
		this.state.typeVal = this.enum.typeStalling;
		this.state.marineVal = this.enum.marineHarbor;
		this.state.storageVal = this.enum.storageSelfStorage;
		this.state.objectVal = this.enum.objectCaravan;
		this.state.workspaceVal = this.enum.workspaceSpace;
		this.state.garageboxVal = this.enum.garageboxSpace;
		this.state.locationVal = this.enum.locationAll;
	},

	// Listener
	setListener(){
		this.el.btnListTypes.forEach(e => {e.addEventListener('click', this.btnClickAction.bind(this))});
		this.el.btnListForBtn.forEach(e => {e.addEventListener('click', this.btnClickAction.bind(this))});
		this.el.btnListLocationBtn.forEach(e => {e.addEventListener('click', this.btnClickAction.bind(this))});
		this.btn.search.addEventListener('click', this.searchAction.bind(this));
	},

	// Action
	btnClickAction(e){
		let p = e.target.parentElement;
		let v = e.target.getAttribute('data-value');
		if(p === this.el.btnListType){this.state.typeVal = v;}
		if(p === this.el.btnListMarine){this.state.marineVal = v;}
		if(p === this.el.btnListStorage){this.state.storageVal = v;}
		if(p === this.el.btnListObject){this.state.objectVal = v;}
		if(p === this.el.btnListLocation){
			this.state.locationVal = v;
			this.searchAction();
		}
		this.render();
	},

	searchAction(){
		let t = '';
		let f = [];
		// Do search
		if(this.state.typeVal === this.enum.typeMarine){
			if(this.state.marineVal === this.enum.marinaPasserby){t = '/jachthaven';}
			if(this.state.marineVal === this.enum.marineHarbor){t = '/jachthaven';}
			if(this.state.marineVal === this.enum.marineDry){t = '/bootstalling';}
		}
		if(this.state.typeVal === this.enum.typeStalling){
			if(this.state.objectVal === this.enum.objectCaravan){t = '/caravanstalling';}
			if(this.state.objectVal === this.enum.objectMotorHome){t = '/camperstalling';}
			if(this.state.objectVal === this.enum.objectCar){t = '/autostalling';}
			if(this.state.objectVal === this.enum.objectBoat){t = '/bootstalling';}
			if(this.state.objectVal === this.enum.objectTrailer){t = '/aanhangerstalling';}
			if(this.state.objectVal === this.enum.objectFoldingTrailer){t = '/vouwwagenstalling';}
			if(this.state.objectVal === this.enum.objectOldtimer){t = '/oldtimerstalling';}
			if(this.state.objectVal === this.enum.objectMotorbike){t = '/motorstalling';}
		}
		if(this.state.typeVal === this.enum.typeStorage){
			t = '/opslagruimte';
			if(this.state.storageVal === this.enum.storageSelfStorage){
				f.push('self-service=ja');
			}
			if(this.state.storageVal === this.enum.storageHomeService){
				f.push('haal-breng-service=ja');
			}
			if(this.state.storageVal === this.enum.storageContainer){
				f.push('gebied=buiten');
			}
		}
		if(this.state.typeVal === this.enum.typeGaragebox){t = '/garageboxen';}
		if(this.state.typeVal === this.enum.typeWorkspace){t = '/bedrijfsruimte';}

		// Location
		let l = '/aanbod';
		if(this.state.locationVal && this.state.locationVal !== this.enum.locationAll){
			l = '/nabij/' + this.state.locationVal;
		}

		if(t){
			f = f.length ? '?' + f.join('&') : '';
			document.location = t + l + f;
			return;
		}

		console.error(t, l, 'Unknown')
	},

	// State
	setState(){},

	// Render
	render() {
		this.renderBtn();
		this.renderFor();
		this.renderImg();
		if(this.state.firstRender){this.state.firstRender = false;}
	},

	renderImg(){
		let file = null;
		if(this.state.typeVal === this.enum.typeMarine){
			file = this.state.marineVal;
		}
		if(this.state.typeVal === this.enum.typeStorage){
			file = this.state.storageVal;
		}
		if(this.state.typeVal === this.enum.typeStalling){
			file = this.state.objectVal;
		}
		if(this.state.typeVal === this.enum.typeWorkspace){
			file = this.state.workspaceVal;
		}
		if(this.state.typeVal === this.enum.typeGaragebox){
			file = this.state.workspaceVal;
		}
		if(file){
			let url = "/image/home/top/" + file + ".jpg";
			if(this.state.firstRender){
				this.el.img.style.backgroundImage = "url('" + url + "')";
			}
			else{
				let img = new Image(); // Preload
				img.src = url;
				this.el.img.style.opacity = '.9';
				img.onload = function (){
					this.el.img.style.backgroundImage = "url('" + url + "')";
					this.el.img.style.opacity = '1';
				}.bind(this);
			}
		}
		else{
			console.error('unknown img');
		}
	},
	renderBtn(){
		// First clean every btn
		this.el.btnListType.querySelectorAll('.active').forEach(e => e.classList.remove('active'));
		this.el.btnListFor.querySelectorAll('.active').forEach(e => e.classList.remove('active'));
		this.el.btnListLocation.querySelectorAll('.active').forEach(e => e.classList.remove('active'));

		// Set btn state
		if(this.state.typeVal){
			let btn = this.el.btnListType.querySelector('button[data-value=' + this.state.typeVal+ ']');
			if(btn){ btn.classList.add('active');}
		}
		if(this.state.marineVal){
			let btn = this.el.btnListMarine.querySelector('button[data-value=' + this.state.marineVal+ ']');
			if(btn){ btn.classList.add('active');}
		}
		if(this.state.storageVal){
			let btn = this.el.btnListStorage.querySelector('button[data-value=' + this.state.storageVal+ ']');
			if(btn){ btn.classList.add('active');}
		}
		if(this.state.objectVal){
			let btn = this.el.btnListObject.querySelector('button[data-value=' + this.state.objectVal+ ']');
			if(btn){ btn.classList.add('active');}
		}
		if(this.state.workspaceVal){
			let btn = this.el.btnListWorkspace.querySelector('button[data-value=' + this.state.workspaceVal+ ']');
			if(btn){ btn.classList.add('active');}
		}
		if(this.state.garageboxVal){
			let btn = this.el.btnListGaragebox.querySelector('button[data-value=' + this.state.garageboxVal+ ']');
			if(btn){ btn.classList.add('active');}
		}
		if(this.state.locationVal){
			let btn = this.el.btnListLocation.querySelector('button[data-value=' + this.state.locationVal+ ']');
			if(btn){ btn.classList.add('active');}
		}
	},
	renderFor(){
		panel.set(this.el.btnListMarine, this.state.typeVal === this.enum.typeMarine);
		panel.set(this.el.btnListStorage, this.state.typeVal === this.enum.typeStorage);
		panel.set(this.el.btnListObject, this.state.typeVal === this.enum.typeStalling);
		panel.set(this.el.btnListWorkspace, this.state.typeVal === this.enum.typeWorkspace);
		panel.set(this.el.btnListGaragebox, this.state.typeVal === this.enum.typeGaragebox);
	}
}

const invoicePayView = {
	// Elements
	field: {
		payOption: document.querySelectorAll('input[name="pay_option"]'),
	},
	state:{
		payOption: null,
	},

	init() {
		this.setListener();
		this.setState();
		this.render();
	},

	setListener() {
		document.querySelectorAll('.js-pay-option').forEach((e) => {
			e.addEventListener('click', this.onFieldChange.bind(this));
		})
	},

	setState(){
		this.state.payOption = this.findCheckValue(this.field.payOption);
	},

	findCheckValue(obs){
		for(var i = 0; i < obs.length; i++){
			if(obs[i].checked){
				return obs[i].value;
			}
		}
	},

	// Actions
	onFieldChange(){
		this.setState();
		this.render();
	},

	render() {
		this.renderPanel();
	},

	renderPanel () {
		let list = document.querySelectorAll('[data-compare]');
		list.forEach((e) => {
			panel.set(e, this.state.payOption === e.dataset.compare);
		})
	}
}

let leadView = {
	field: {
		postcode: document.getElementById("js-postcode-field"),
		houseNumber: document.getElementById("js-house_number-field"),
		street: document.getElementById("js-street-field"),
		city: document.getElementById("js-city-field"),
	},
	state:{
		postcode: null,
		houseNumber: null,
		street: null,
		city: null,
	},
	enum:{
	},
	json: {
		postcodeInfo: null
	},
	request:{
		address: {url: null, data: {postcode: null, number: null, street: null, city: null}, timeout: null},
	},

	// Func
	init() {
		this.setListener();
		this.setDefault();
		this.updateState();
		this.render();
	},

	// Set
	setDefault(){
		this.state.typeVal = this.enum.typeStalling;
		this.state.marineVal = this.enum.marineHarbor;
		this.state.storageVal = this.enum.storageSelfStorage;
		this.state.objectVal = this.enum.objectCaravan;
		this.state.workspaceVal = this.enum.workspaceSpace;
		this.state.garageboxVal = this.enum.garageboxSpace;
		this.state.locationVal = this.enum.locationAll;
	},

	// Listener
	setListener(){
		this.field.postcode ? this.field.postcode.addEventListener('keyup', function () {this.update()}.bind(this)) : null;
		this.field.houseNumber ? this.field.houseNumber.addEventListener('keyup', function () {this.update()}.bind(this)) : null;
	},

	update(){
		this.updateState();
		this.checkPostcode();
		// this.render();
	},

	// Action
	checkPostcode(){
		if(!this.state.postcode || this.state.postcode.length < 6 || !this.state.houseNumber){
			if(this.request.address.timeout){clearTimeout(this.request.address.timeout);}
			return;
		}

		// Check on url call
		let url = '/api/book/address/' + this.state.postcode + '/' +this.state.houseNumber;
		if(this.request.address.url === url){
			return;
		}
		this.request.address.url = url;

		// Call to
		if(this.request.address.timeout){clearTimeout(this.request.address.timeout);}
		this.request.address.timeout = setTimeout(() => {
			requestHelper.getFetchJsonOb(url)
				.then(o => {
					if(o.response.status !== 200){
						this.field.street.value = '';
						this.field.city.value = '';
						return;
					}
					if(o.json.data){
						this.request.address.data = o.json.data;
						this.field.postcode.value = this.request.address.data.postcode;
						this.field.houseNumber.value = this.request.address.data.number;
						this.field.street.value = this.request.address.data.street;
						this.field.city.value = this.request.address.data.city;
					}
				})
				.catch(e => console.error(e));
		}, 400);
	},

	// State
	updateState(){
		this.state.postcode = this.field.postcode ? this.field.postcode.value.replace(/\s/g, ''): null;
		this.state.houseNumber = this.field.houseNumber ? this.field.houseNumber.value : null;
	},

	// Render
	render() {
	},

}

let offerView = {
	el:{
		searchForm: document.getElementById('home-search'),
		searchBar: document.getElementById('search-bar'),
		searchQ: document.getElementById('q-id'),
		searchResult: document.getElementById('search-bar-results'),
	},
	state:{
		searchTimer: null,
		previousSearch: '',
		autocompleteList: [],
	},

	// Func
	init() {
		this.setListener();
	},

	// Listener
	setListener(){
		this.el.searchBar.addEventListener('keyup', this.actionSearchKeyPress.bind(this));
	},

	actionSearchKeyPress(e){
		let input = e.target
		if (e.key === "ArrowUp" || e.key === "ArrowDown") {
			let listOfLiItems = document.getElementById('search-bar-results-view').children;
			let previousItemKey = 0;
			for (let i = 0; i < listOfLiItems.length; i++) {
				if (listOfLiItems[i].className === 'select-by-key') {
					listOfLiItems[i].className = '';
					if (e.code === "ArrowUp") {
						previousItemKey = i - 1;
					} else if (e.code === "ArrowDown") {
						previousItemKey = i + 1;
					}
				}
			}
			if (listOfLiItems[previousItemKey]) {
				listOfLiItems[previousItemKey].className = 'select-by-key';
				document.getElementById('search-bar').value = listOfLiItems[previousItemKey].dataset.content;
				if (listOfLiItems[previousItemKey].dataset.link) {
					document.getElementById('search-bar').value = this.state.previousSearch;
				}
			} else {
				document.getElementById('search-bar').value = this.state.previousSearch;
			}
		}
		else{
			document.getElementById('q-id').value = '';
			if(this.state.previousSearch !== input.value) {
				this.state.previousSearch = input.value;
				this.showResult(input.value);
			}
			if(!input.value){
				this.renderSearchBarDisplay(false);
			}
		}
	},
	showResult(str) {
		let beforeThis = this;
		let xmlHttp = new XMLHttpRequest();
		xmlHttp.onreadystatechange= function() {
			if (this.readyState===4 && this.status===200) {
				beforeThis.state.autocompleteList = [];
				let json = JSON.parse(this.responseText);
				let view = document.getElementById('search-bar-results-view');
				view.innerHTML = '';

				if( ! json.results) {
					beforeThis.renderSearchBarDisplay(false);
					return false;
				}

				if(json.results && json.results.length > 0) {
					for(let i = 0; i < json.results.length; i++) {
						let itemNumber = json.results[i].number;
						if( ! itemNumber)
							itemNumber = '';
						if(json.results[i].link === ""){
							beforeThis.state.autocompleteList = json.results;
						}
						let li = document.createElement('li');
						li.dataset.content = json.results[i].name;
						li.dataset.link = json.results[i].link;
						li.addEventListener('click', beforeThis.renderSearchBarText.bind(beforeThis, json.results[i].name.replace("'",''), json.results[i].id, json.results[i].link));
						li.innerHTML = '<div class="regel">' + json.results[i].name + '<span>' + itemNumber + '</span></div><div class="search-type">' + json.results[i].type + '</div>';
						view.appendChild(li);
					}
					beforeThis.renderSearchBarDisplay(true);
				}
				else {
					beforeThis.renderSearchBarDisplay(false);
				}
			}
		}

		let type = document.getElementById('q-stalling').value;
		type = type.replace('stalling','');
		type = type.replace('ruimte','');
		if(!type){
			type = 'caravan';
		}

		xmlHttp.open("GET","/api/search/home/" + type + "/" + encodeURIComponent(str), true);
		if(this.state.searchTimer){
			clearTimeout(this.state.searchTimer);
		}
		this.state.searchTimer = setTimeout(function() {xmlHttp.send();}, 400);
	},

	// Render
	renderSearchBarText(text, id, link){
		if(link){
			window.location.href = link;
		}
		else {
			this.el.searchQ.value = id;
			this.el.searchBar.value = text;
			this.el.searchForm.submit();
		}
	},
	renderSearchBarDisplay(state){
		this.el.searchResult.style.display = state ? 'block' : 'none';
		if( ! document.getElementById('box-first-a')){
			return true;
		}
		if(state) {
			if(window.innerWidth < 600) {
				document.getElementsByClassName('box-first')[0].style.opacity = '0.1';
				document.getElementById('box-first-a').style.display = 'none';
			}
		}
		else {
			document.getElementsByClassName('box-first')[0].style.opacity = '1';
			document.getElementById('box-first-a').style.display = 'block';
		}
	}
}

const passerbyBookView = {
	el:{
		conform:{
			title: document.getElementById('conform-title'),
			startDate: document.getElementById('conform-start_date'),
		},
		img: document.querySelector('.box-info'),
		btn:{
			backList: document.querySelectorAll('.js-btn-back'),
			nextList: document.querySelectorAll('.js-btn-next'),
			send: document.querySelector('.js-btn-send'),
		},
		message:{
			startHour: document.getElementById('message-start_hour'),
			endHour: document.getElementById('message-end_hour'),
			start: document.getElementById('message-start_date'),
			end: document.getElementById('message-end_date'),
		},
		panel:{
			inputPlace: document.getElementById('panel-input-place'),
			tourist: document.getElementById('tourist-place'),
		},
		confirm:{
			name: document.getElementById('confirm-name'),
			boot: document.getElementById('confirm-boot'),
			place: document.getElementById('confirm-place'),
			period: document.getElementById('confirm-period'),
			priceReservation: document.getElementById('confirm-price-reservation'),
			priceTourist: document.getElementById('confirm-price-tourist'),
			priceTotal: document.getElementById('confirm-price-total'),
		},
	},
	field:{
		// Boot
		bootName: document.querySelector('input[name=boot_name]'),
		bootLength: document.querySelector('input[name=boot_length]'),
		bootWidth: document.querySelector('input[name=boot_width]'),
		// Reservation
		startDate: document.querySelector('input[name=start_date]'),
		endDate: document.querySelector('input[name=end_date]'),
		place: document.querySelector('select[name=place]'),
		// User
		firstName: document.querySelector('input[name=first_name]'),
		lastName: document.querySelector('input[name=last_name]'),
		mobile: document.querySelector('input[name=mobile]'),
		mobileCounty: document.querySelector('select[name=mobile_country]'),
		mail: document.querySelector('input[name=mail]'),
		tourist: document.querySelector('input[name=tourist]'),
		// Confirm
	},
	sheet:{
		all: document.querySelectorAll('.sheet'),
	},
	state: {
		locationId: null,
		sheet: null,
		showNextButton: true,
		hasError: null,// Last error
		// Boot
		bootName: null,
		bootLength: null,
		bootWidth: null,
		// Reservation
		startDate: null,
		endDate: null,
		placeId: null,

		// User
		firstName: null,
		lastName: null,
		mobile: null,
		mobileCountry: null,
		mail: null,
		tourist: null,

		// Confirm
		note: null,

		// Error
		errorFieldList: [],
		errorLastSheet: null,
	},
	request:{
		place: {url:null,data:null},
	},
	enum:{
		sheet: {
			boot: 'boot',
			reservation: 'reservation',
			user: 'user',
			confirm: 'confirm',
			receipt: 'receipt',
		},
	},
	prefer:{
		csrf: null,
		locationId: null,
		startDate: new Date(),
		mail: null,
	},
	config:{
		startHour: null,
		endHour: null,
		priceType: null,
		rent: null,
		rentMin: null,
		tourist: null,
	},

	init(){
		this.setDefault();
		this.setListener();
		this.updateState();
		this.render();
	},
	setDefault() {
		this.state.sheet = this.enum.sheet.boot;
		this.el.message.startHour.innerHTML = 'vanaf ' + this.config.startHour;
		this.el.message.endHour.innerHTML = 'tot ' + this.config.endHour;
	},
	setListener(){
		this.field.startDate.addEventListener('input', this.onFieldChange.bind(this));
		this.field.endDate.addEventListener('input', this.onFieldChange.bind(this));
		this.el.btn.backList.forEach(function (e){
			e.addEventListener('click', this.setSheet.bind(this, 'back'));
		}.bind(this));
		this.el.btn.nextList.forEach(function (e){
			e.addEventListener('click', this.setSheet.bind(this, 'next'));
		}.bind(this));
		this.el.btn.send.addEventListener('click', this.send.bind(this));
	},
	updateState(){
		this.setState();
		this.updateRequest();
	},
	setState(){
		// Boot
		this.state.bootName = this.field.bootName ? this.field.bootName.value : null;
		this.state.bootLength = this.field.bootLength ? parseInt(this.field.bootLength.value) : null;
		this.state.bootWidth = this.field.bootWidth ? parseInt(this.field.bootWidth.value) : null;
		// Reservation
		this.state.startDate = this.field.startDate ? this.field.startDate.valueAsDate : this.prefer.startDate;
		this.state.endDate = this.field.endDate ? this.field.endDate.valueAsDate : null;
		this.state.placeId = this.field.place ? parseInt(this.field.place.value) : null;
		// User
		this.state.firstName =  this.field.firstName ? this.field.firstName.value : null;
		this.state.lastName =  this.field.lastName ? this.field.lastName.value : null;
		this.state.mobile =  this.field.mobile ? this.field.mobile.value : null;
		this.state.mobileCountry =  this.field.mobileCounty ? this.field.mobileCounty.value : null;
		this.state.mail = this.field.mail ? this.field.mail.value : null;
		this.state.tourist = this.field.tourist ? parseInt(this.field.tourist.value) : null;
		// Confirm
		this.state.note = this.field.note ? this.field.note.value : null;
	},
	onFieldChange(e){
		this.updateState();
		this.updateRequest();
		if(this.state.sheet === this.enum.sheet.reservation){
			this.renderSheetReservation();
		}
		this.render();
	},
	updateRequest(){
		if(this.state.sheet === this.enum.sheet.reservation){
			if(!this.state.locationId || !this.state.startDate || !this.state.endDate || !this.state.bootLength || !this.state.bootWidth){
				this.request.place.url = null;
				return;
			}
			let url = '/api/passerby/place/' + this.state.locationId
				+ '/' + inputDateForState.dateToEn(this.state.startDate)
				+ '/' + inputDateForState.dateToEn(this.state.endDate)
				+ '?l=' + this.state.bootLength + '&w=' + this.state.bootWidth
			if(this.request.place.url !== url){
				this.request.place = requestHelper.getOb(url);
			}
		}
	},

	// Actions
	setSheet(name){
		this.setState(); // Update state
		this.state.hasError = null;

		let to = '';
		if(name === 'next'){
			if(this.state.sheet === this.state.errorLastSheet){
				this.state.errorLastSheet = null;
				this.state.errorFieldList = null;
			}
			this.state.hasError = this.validate();
			if(this.state.hasError){
				this.render();
				return;
			}

			if(this.state.sheet === this.enum.sheet.boot) {
				to = this.enum.sheet.reservation;
			} else if(this.state.sheet === this.enum.sheet.reservation){
				to = this.enum.sheet.user;
			} else if(this.state.sheet === this.enum.sheet.user){
				to = this.enum.sheet.confirm;
			} else{
				return console.error('unknown sheet', this.state.sheet);
			}
		}
		else if(name === 'back'){
			if(this.state.sheet === this.enum.sheet.reservation){to = this.enum.sheet.boot;}
			else if(this.state.sheet === this.enum.sheet.user){to = this.enum.sheet.reservation;}
			else if(this.state.sheet === this.enum.sheet.confirm){to= this.enum.sheet.user}
			else{
				return console.error('unknown action');
			}
		}
		else{
			to = name;
		}
		this.state.sheet = to;
		this.updateState();
		this.render();
	},

	openLink(link){
		// Fix issue then book module is in iframe!
		top.window.location.href = link;
	},
	// Validate
	validate(){
		if(this.state.sheet === this.enum.sheet.boot){
			if(!this.state.bootName){
				return 'Mist boot naam';
			}
			if(!this.state.bootLength || this.state.bootLength < 10){
				return 'Mist lengte';
			}
			if(!this.state.bootWidth || this.state.bootWidth < 10){
				return 'Mist breedte';
			}
		}
		if(this.state.sheet === this.enum.sheet.reservation){
			if(!this.state.startDate){
				return 'Mist startdatum';
			}
			if(!this.state.endDate){
				return 'Mist einddatum';
			}
			if(inputDateForState.diffInDay(this.state.startDate, this.state.endDate) < 1){
				return 'Einddatum moet 1 dag na startdatum zijn';
			}
			if(!this.state.placeId){
				return 'Mist plek';
			}
		}
		if(this.state.sheet === this.enum.sheet.user){
			if(!this.state.firstName){
				return 'Mist voornaam';
			}
			if(!this.state.lastName){
				return 'Mist achternaam';
			}
			if(!this.state.mobile){
				return 'Mist mobiel';
			}
			if(this.config.tourist > 0 && !this.state.tourist && this.state.tourist !== 0){
				return 'Mist toeristenbelasting info';
			}
		}
		return null;
	},
	showValidationError(){
		// Set api error field
		let errMsg = '';
		if(this.state.errorFieldList){
			for (const [field, notes] of Object.entries(this.state.errorFieldList)) {
				if(notes){errMsg += notes;}
			}
		}

		let errorBoxList = document.querySelectorAll('.sheet .error-box');
		let el = document.querySelector('div[data-sheet=' + this.state.sheet +'] .error-box');
		errorBoxList.forEach(e => {panel.hide(e);});
		if(this.state.hasError){errMsg += this.state.hasError;}
		if(errMsg){
			panel.show(el);
			el.innerHTML = errMsg;
		}
	},
	send(){
		this.updateState();
		let jsonOb = {
			// Welcome
			location_id: this.state.locationId,

			// Boot
			boot_name: this.state.bootName,
			boot_length: this.state.bootLength,
			boot_width: this.state.bootWidth,
			// Reservation
			start_date: this.state.startDate,
			end_date: this.state.endDate,
			place_id: this.state.placeId,
			// User
			first_name: this.state.firstName,
			last_name: this.state.lastName,
			mobile: this.state.mobile,
			mobile_country: this.state.mobileCountry,
			mail: this.state.mail,
			tourist: this.state.tourist,
			// Confirm
			note: this.state.note,
		};
		let json = JSON.stringify(jsonOb);
		let handle = function (e){
			let xhr = e.currentTarget;
			if(xhr.readyState !== 4){
				return;
			}
			this.state.errors = null;
			if(xhr.status === 200){
				let json = JSON.parse(xhr.response);

				this.openLink(json.link);

				return;
			}

			// Error
			let errors = JSON.parse(xhr.response);
			let toastMsg = errors.toast ? errors.toast : 'Status code: ' + xhr.status;
			// Errors
			this.state.errorFieldList = errors.field;
			this.state.errorLastSheet = errors.sheet;
			this.setSheet(errors.sheet);
			toast.error(toastMsg);
		}
		requestHelper.post('/api/passerby/store', json, handle.bind(this), true, this.prefer.csrf);
	},

	// Render
	render(){
		this.renderSheet();
		this.showValidationError();

	},
	renderSheet(){
		this.sheet.all.forEach(e => {
			panel.set(e, this.state.sheet === e.getAttribute('data-sheet'));
		});

		// Render sheet elements
		if(this.state.sheet === this.enum.sheet.boot){this.renderSheetBoot();}
		if(this.state.sheet === this.enum.sheet.reservation){this.renderSheetReservation();}
		if(this.state.sheet === this.enum.sheet.user){this.renderSheetUser();}
		if(this.state.sheet === this.enum.sheet.confirm){this.renderSheetConfirm();}
		this.renderNextButton();
	},

	renderNextButton(){
		this.el.btn.nextList.forEach(e => {
			panel.set(e, this.state.showNextButton);
		});
	},

	renderSheetBoot(){},
	renderSheetUser(){
		panel.hide(this.el.panel.tourist);
		if(this.config.tourist > 0){
			panel.show(this.el.panel.tourist);
		}
	},
	renderSheetReservation(){
		let hasPlaceList = this.request.place.url;
		panel.set(this.el.panel.inputPlace, hasPlaceList);
		panel.hide(this.el.message.start);
		panel.hide(this.el.message.end);

		// Set min
		this.field.startDate.min = inputDateForState.dateToEn(new Date());
		let minEndDate = new Date(this.state.startDate.getTime());
		minEndDate.setDate(minEndDate.getDate() + 1);
		this.field.endDate.min = inputDateForState.dateToEn(minEndDate);

		// Message

		// Set select
		selectHelper.removeAll(this.field.place);
		selectHelper.add(this.field.place, '', 'Kies een plek', true, false);
		if(hasPlaceList){
			this.request.place.data.list.forEach( e => {
				selectHelper.add(this.field.place, e.id, e.dropdown, this.state.placeId === e.id, e.disabled);
			})
		}
	},
	renderSheetConfirm(){
		this.el.confirm.name.innerHTML = this.state.firstName + ' ' + this.state.lastName;
		this.el.confirm.boot.innerHTML = this.state.bootName + ', ' + this.state.bootLength + ' x ' + this.state.bootWidth + ' cm';
		this.el.confirm.period.innerHTML = inputDateForState.dateToNlLocal(this.state.startDate)
			+ ' ' + this.config.startHour
			+ ' t/m '
			+ inputDateForState.dateToNlLocal(this.state.endDate)
			+ ' ' + this.config.endHour;
		// PLace
		let placeInfo = this.request.place.data.list.find(e => e.id === this.state.placeId);
		if(placeInfo){
			this.el.confirm.place.innerHTML = placeInfo.name;
		}
		// Price
		let diffInDay = inputDateForState.diffInDay(this.state.startDate, this.state.endDate);
		if(diffInDay < 1){
			this.el.confirm.priceTotal.innerHTML = 'Datum onjuist';
		} else{
			let isMinPrice = false;
			let priceForRent = this.config.rent * diffInDay;
			if(this.config.priceType === enumList.passerbyInfo.priceType.variable){
				priceForRent *=  Math.abs(this.state.bootLength / 100);
			}
			if(this.config.rentMin && priceForRent < this.config.rentMin){
				isMinPrice = true;
				priceForRent = this.config.rentMin;
			}
			let priceForTourist = this.config.tourist ? this.config.tourist * this.state.tourist * diffInDay : 0; // Price can be zero!
			let priceForTotal = priceForRent + priceForTourist;
			this.el.confirm.priceReservation.innerHTML = '€' + priceHelper.fromCentToNl(priceForRent)
				+ ' ' + (isMinPrice ? ' (min prijs)' : '')
				+ ' voor ' + (diffInDay === 1 ? ' 1 dag' : diffInDay + ' dagen');
			this.el.confirm.priceTourist.innerHTML = this.config.tourist === 0 ? '-' :
				'€' + priceHelper.fromCentToNl(priceForTourist) + ' voor '
				+ (this.state.tourist === 1 ? '1 persoon' : this.state.tourist + ' personen');
			this.el.confirm.priceTotal.innerHTML = '€' + priceHelper.fromCentToNl(priceForTotal);
		}
	},
};



let priceCalculator = {
	priceTable: null,
	typeInfoId: null,

	// Item
	packageItem: document.getElementById('packageItem'),
	typeLengthItem: document.getElementById('typeLengthItem'),
	typeWidthItem: document.getElementById('typeWidthItem'),
	typeHeightItem: document.getElementById('typeHeightItem'),
	typeVolumeItem: document.getElementById('typeVolumeItem'),
	typeSquareItem: document.getElementById('typeSquareItem'),
	winterItem: document.getElementById('winterItem'),

	// Fields
	field: {
		priceId: document.getElementById('priceIdField'),
		type: document.getElementById('typeField'),
		package: document.getElementById('packageField'),
		winter: document.getElementById('winterField'),
		typeLength: document.getElementById('typeLengthField'),
		typeWidth: document.getElementById('typeWidthField'),
		typeHeight: document.getElementById('typeHeightField'),
		typeVolume: document.getElementById('typeVolumeField'),
		typeSquare: document.getElementById('typeSquareField'),
		services: document.getElementsByClassName('serviceCalculation'),
	},

	// Text
	packageDescriptionText: document.getElementById('packageDescriptionText'),
	priceText: document.getElementById('priceText'),
	priceDescriptionText: document.getElementById('priceDescriptionText'),
	priceDescriptionServiceText: document.getElementById('priceDescriptionServiceText'),
	priceDescriptionStartupText: document.getElementById('priceDescriptionStartupText'),
	priceDescriptionDepositText: document.getElementById('priceDescriptionDepositText'),

	// State
	showLengthState: false,
	showWidthState: false,
	showHeightState: false,
	showVolumeState: false,
	showSquareState: false,
	showWinterState: false,
	lastPriceOb: null,
	yearPrice: 0,
	servicePrice: 0,
	startupPrice: 0,
	depositPrice: 0,
	packageDescriptionTextState: "",
	squareSizeForPackageState: null,
	squareSelectedItem: null,
	storageSizeForPackageState: null,
	storageSelectedItem: null,
	winterPriceState: false,

	// Display
	fieldPricePerMonth: document.getElementById('fieldPricePerMonth'),

	calculate: function () {
		let priceTypeList = this.priceTable.packageList[this.field.package.value];
		let lowerPriceItem = null;
		let determineWidth = false;
		let determineLength = false;

		// Storage
		if(this.typeInfoId === enumList.typeInfo.id.storage){
			this.showVolumeState = true;
			determineLength = false;

			// Set sizes
			if(this.storageSizeForPackageState !== this.field.package.value){
				removeSelectItems(this.field.typeVolume);
				for (let i = 0; i < priceTypeList.length; i++) {
					let item = priceTypeList[i]
					if(!lowerPriceItem){
						lowerPriceItem = item;
					}
					let option = document.createElement("option");
					option.text = formatHelper.volumeToNl(item.volume_m) + ' m³' + (item.floor ? ' - etage ' + item.floor : '');
					option.value = item.id;
					if(option.value === this.storageSelectedItem){
						option.selected = true;
						lowerPriceItem = item;
					}
					this.field.typeVolume.add(option);
				}
				this.storageSizeForPackageState = this.field.package.value;
			}
			else{
				// Find in price list
				for (let i = 0; i < priceTypeList.length; i++) {
					let item = priceTypeList[i]
					if(item.id === parseInt(this.field.typeVolume.value)){
						lowerPriceItem = priceTypeList[i];
						console.log('FOUND',  this.field.typeVolume.value, item.id,lowerPriceItem )
						break;
					}
				}
			}
		}
		else if(this.typeInfoId === enumList.typeInfo.id.workspaces || this.typeInfoId === enumList.typeInfo.id.garagebox){
			this.showSquareState = true;
			determineLength = false;

			// Set sizes
			if(this.squareSizeForPackageState !== this.field.package.value){
				removeSelectItems(this.field.typeSquare);
				for (let i = 0; i < priceTypeList.length; i++) {
					let item = priceTypeList[i]
					if(!lowerPriceItem){
						lowerPriceItem = item;
					}
					let option = document.createElement("option");
					option.text = formatHelper.volumeToNl(item.square_m) + ' m²' + (item.floor ? ' - etage ' + item.floor : '');
					option.value = item.id;
					if(option.value === this.squareSelectedItem){
						option.selected = true;
						lowerPriceItem = item;
					}
					this.field.typeSquare.add(option);
				}
				this.squareSizeForPackageState = this.field.package.value;
			}
			else{
				// Find in price list
				for (let i = 0; i < priceTypeList.length; i++) {
					let item = priceTypeList[i]
					if(item.id === parseInt(this.field.typeSquare.value)){
						lowerPriceItem = priceTypeList[i];
						break;
					}
				}
			}
		}
		else{
			// Normal
			determineLength = true; // For service calculation
			determineWidth = true; // For service calculation
			for (let i = 0; i < priceTypeList.length; i++) {
				let item = priceTypeList[i]
				if (lowerPriceItem == null || item.base < lowerPriceItem.base){
					// -- Check also Price model --
					// Length
					if(item.max_length_cm != null && this.field.typeLength.value > item.max_length_cm) {continue;}
					// Width
					if(item.max_width_cm != null && this.field.typeWidth.value > item.max_width_cm) {continue;}
					// Height
					if(item.max_height_cm != null && this.field.typeHeight.value > item.max_height_cm) {continue;}
					lowerPriceItem = item;
				}
			}
			// No choose
			if(priceTypeList.length === 1){
				if(lowerPriceItem.type !== priceHelper.priceTypeVariableM2){
					determineWidth = false;
				}
				if(lowerPriceItem && lowerPriceItem.type === priceHelper.priceTypeFixed){
					determineLength = false;
				}
			}
		}

		// No price package
		if(!lowerPriceItem || !this.field.typeLength.value){
			this.yearPrice = 0;
			this.showLengthState = true;
			this.showWidthState = true;
			this.showHeightState = false;
			this.showWinterState = false;
			this.showVolumeState = false;
			this.showSquareState = false;
			return this.render();
		}

		// Set fields
		this.showWinterState = (lowerPriceItem.winter > 0);
		this.showLengthState = determineLength;
		this.showWidthState = determineWidth;
		this.lastPriceOb = lowerPriceItem;

		// Set price
		let fixedPrice = 0;
		if(lowerPriceItem.type === priceHelper.priceTypeFixed){
			fixedPrice = 1;
		}else if(lowerPriceItem.type === priceHelper.priceTypeVariable){
			fixedPrice = parseFloat(this.field.typeLength.value / 100);
		}else if(lowerPriceItem.type === priceHelper.priceTypeVariableM2){
			fixedPrice = parseFloat((this.field.typeLength.value / 100) * (this.field.typeWidth.value / 100));
		}else{
			console.error('unknown price type: ' + lowerPriceItem.type);
			return;
		}

		if(this.field.winter.value == 1 && this.showWinterState){
			this.winterPriceState = true;
			this.yearPrice = parseFloat(lowerPriceItem.winter) * fixedPrice;
		}
		else{
			this.winterPriceState = false;
			this.yearPrice = parseFloat(lowerPriceItem.base) * fixedPrice;
		}
		// Set price id for reservation
		if(this.field.priceId){
			this.field.priceId.value = lowerPriceItem.id;
		}

		// Min price *1 make string to float
		if(this.yearPrice < parseFloat(lowerPriceItem.min)){
			this.yearPrice = parseFloat(lowerPriceItem.min);
		}

		// Create description
		let priceRequest = lowerPriceItem.price_request;
		this.packageDescriptionTextState =
			(lowerPriceItem.description ? lowerPriceItem.description + "<br>": '' )
			+ "<small>Aantal ophaalafspraken: "
			+ (lowerPriceItem.request_pickup_max === -1 ? "onbeperkt": lowerPriceItem.request_pickup_max)
			+ (lowerPriceItem.request_pickup_max === -1 ? "" :
				( lowerPriceItem.price_request ? "  ·  Extra afspraak: " + priceRequest : "")
			)
			+ "</small>";

		// Service
		this.servicePrice = 0;
		for (let i = 0; i < this.field.services.length; i++) {
			let item = this.field.services[i];
			let id = item.value;
			if(item.checked && this.priceTable.serviceList[id]){
				this.calculateServicePrice(this.priceTable.serviceList[id]);
			}
		}

		// Startup costs
		this.startupPrice = parseFloat(lowerPriceItem.price_startup);
		this.depositPrice = parseFloat(lowerPriceItem.price_deposit);

		this.render();
	},
	render: function(){
		panel.set(this.typeLengthItem, this.showLengthState)
		panel.requiredChange(this.field.typeLength, this.showLengthState);
		if(!this.showLengthState){
			this.field.typeLength.min = '';
		}

		this.typeWidthItem.style.display = this.showWidthState ? '' : 'none';
		this.typeHeightItem.style.display = this.showHeightState ? '' : 'none';
		this.typeVolumeItem.style.display = this.showVolumeState ? '' : 'none';
		this.typeSquareItem.style.display = this.showSquareState ? '' : 'none';
		this.winterItem.style.display = this.showWinterState ? '' : 'none';
		if(this.packageDescriptionText){
			this.packageDescriptionText.innerHTML = (this.packageDescriptionTextState) ? this.packageDescriptionTextState: '' ;
		}
		if(this.typeInfoId === enumList.typeInfo.id.storage || this.typeInfoId === enumList.typeInfo.id.workspaces){
			this.priceText.innerHTML = this.yearPrice > 0 ? this.calculateMonthPriceText() : 'Geen pakket' ;
			this.priceDescriptionText.innerHTML = this.yearPrice > 0 ? this.calculateDescriptionPriceText() : '--' ;
		}
		else{
			this.priceText.innerHTML = this.yearPrice > 0 ? this.calculateYearPriceText() : 'Geen pakket' ;
			this.priceDescriptionText.innerHTML = this.yearPrice > 0 ? this.calculateMonthPriceText() : '--' ;
		}

		this.priceDescriptionStartupText.innerText = this.startupPrice > 0 ? this.calculateStartupPriceText() : 'Geen opstartkosten';
		this.priceDescriptionDepositText.innerText = this.depositPrice > 0 ? this.calculateDepositPriceText() : 'Geen borgsom';
		this.drawServiceText();
	},
	calculateDescriptionPriceText: function () {
		let price = this.yearPrice;
		let month = this.winterPriceState ? 6 : 12;
		return month + " x " + priceHelper.toNl(price / month) + " = " + priceHelper.toNl(this.yearPrice) + " per jaar";
	},
	calculateMonthPriceText: function () {
		let month = this.winterPriceState ? 6 : 12;
		return '&euro;' + priceHelper.toNl(this.yearPrice / month) + ' per maand';
	},

	calculateYearPriceText() {
		if(this.lastPriceOb && this.lastPriceOb.period) {
			return '&euro;' + priceHelper.toNl(this.yearPrice) + ' per '
				+ this.lastPriceOb.period
				+ (this.lastPriceOb.period_line ? ' ' + this.lastPriceOb.period_line : '');
		}

		return '&euro;' + priceHelper.toNl(this.yearPrice) + ' per jaar';
	},

	calculateServicePrice: function (ob) {
		let addPrice = 0.0;
		if(ob.type === "fixed"){
			addPrice = parseFloat(ob.base);
		}
		else{
			addPrice = parseFloat(ob.base) * parseFloat(this.field.typeLength.value / 100); // CM to M
			if(parseFloat(ob.min) > addPrice){
				addPrice = parseFloat(ob.min);
			}
		}
		this.servicePrice += addPrice;
	},
	calculateServicePriceText: function () {
		return '+ ' + priceHelper.toNl(this.servicePrice) + ' extra services';
	},
	calculateStartupPriceText: function () {
		return '+ ' + priceHelper.toNl(this.startupPrice) + ' opstartkosten';
	},
	calculateDepositPriceText: function () {
		return '+ ' + priceHelper.toNl(this.depositPrice) + ' borgsom';
	},
	drawServiceText: function () {
		let text = this.servicePrice > 0 ? this.calculateServicePriceText() : '';
		if(text){
			this.priceDescriptionServiceText.innerText = text;
			this.priceDescriptionServiceText.style.display = 'block';
		}
		else{
			this.priceDescriptionServiceText.style.display = 'none';
		}
	}
}
